import React, { memo, useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Badge, Form, Modal, Button } from "react-bootstrap";
import { useHistory, withRouter } from "react-router-dom";
import LanguageContext from "../../../helper/LanguageContext";
import ShareProjectMapDialog from "../../../components/ProjectMapShare/ShareProjectMapDialog";
import { callAPI } from "../../../helper/apiUtils";
import { requestDirectMessage } from "../../../helper/directMessagePrompt";
import { getBuildingChat, invalidateBuildingChat } from "../../../helper/buildingChat";
import { prefetchChatMessages } from "../../../helper/chatMessageCache";
import { applyOptimisticChatRead, getBadgeCount, invalidateBadgeCount } from "../../../helper/badgeCount";
import { decrementRoomUnreadInLists } from "../roomDnd";
import { $crud } from "../../../helper/CrudFactory";
import { assignModalSnapshot, isOutgoingEmail, getEmailListPreview, firstEmailSentence, oneSentenceMessageSummary, cleanChatMessageText } from "../../../helper/emailBodyFormat";
import { beginExternalBookmarkTodo, finishBookmarkTodo, failBookmarkTodo } from "../../../helper/bookmarkTodo";
import CompanyListDialog from "../Dialogs/CompanyListDialog";
import {
  BASE_URL,
  KJUUP_COLORS,
  TOGGLE_DRAWER,
  formatName,
  getAvatarInitials,
} from "../../../helper/constants";
import _ from "lodash";
import {
  FORWARD_GROUP_MESSAGES,
  GROUP_CHATS,
  OPEN_PROJECTS,
  OPEN_CHATS,
  PROJECTS,
  UPDATE_PROJECT_ACTION_FIRE,
  DRAFT_MESSAGES,
  IS_OPEN_BY_OWNER,
  ALL_BADGE_COUNT,
  SET_ALLGROUPS_PROJECTS,
  INTERNAL_PROJECTS,
  OPEN_BOTTOM_PROJECTS,
  SET_ACTIVITY_MESSAGES,
  SET_ACTIVITY_MESSAGES_REMINDERS,
  UPDATE_PROJECT_DETAILS,
  TOGGLE_PROJECT,
  TOGGLE_GROUP_CHAT,
  TOGGLE_LATEST_MSG,
  TOGGLE_TODO_VIEW,
  SET_DEEPLINK_DATA,
  SET_DEEPLINK_LOADING,
  SET_PENDING_EMAIL_OPEN,
  SET_NEW_GROUP_DATA,
  SET_LOADER,
  SET_EMAIL_ACCOUNTS,
  DECREMENT_UNSEEN_EMAIL_COUNT,
  INCREMENT_UNSEEN_EMAIL_COUNT,
  DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT,
  REFRESH_TODO_LIST,
  TODO_ITEM_REMOVED,
  SET_ACTIVE_PINNED_ROOM_ID,
  SET_CHAT_FULLSCREEN,
  SET_OPEN_SIDE_BAR,
  SET_IN_ACTIVITY,
  RIGHT_TOP,
  SET_PENDING_PROJECT_TASK,
  store,
} from "../../../store";
import { connect, useDispatch, useSelector } from "react-redux";
import { canShowEmailCalendarIntegration } from "../../../utils/kjuupIoEntitlement";
import { resolveStripeFlags } from "../../../utils/stripeFeature";
import { PERSONA_IO, chatsHidden, resolveCockpitPersona, teamsClientHidden } from "../../../utils/cockpitPersona";
import { pendingProjectTaskIsFresh } from "../../Cockpit/cockpitNavigation";
import { createInternalEmailRoom } from "../../../utils/emailAssignRoom";
import { classifySpamWithProgress, classifyProjectWithProgress } from "../../../utils/emailClassifyWithProgress";
import EditProject from "../EditProject";
import AddProjectUser from "../AddProjectUser";
import { Scrollbars } from "react-custom-scrollbars";
import { DE } from "../../../Languages/DE";
import { EN } from "../../../Languages/EN";
import * as moment from "moment";
import "../../../styles/pages.css";
import "../../../styles/latestMessages.css";
import AddProjectChatUser from "../AddProjectChatUser";
import GroupConversation from "../GroupChat/GroupConversation";
import { $user } from "../../../helper/UserFactory";
import BuildingMediaDocs from "../BuildingMediaDocs";
import ProjectEmailsSection from "../../../components/mediaSection/ProjectEmailsSection";
import EmailDetailView from "../../../components/EmailDetailView";
import EmailAssignModal from "../../../components/EmailAssignModal";
import DailyBriefingDocument from "../../../components/DailyBriefingDocument";
import EmailFeedRow from "../../../components/EmailFeedRow";
import GroupAvatarImage from "../../../components/GroupAvatarImage";
import { listTeamsProjectChats } from "../../../helper/teamsApi";
import { TEAMS_PROJECT_EVENT, teamsChatEntry } from "../../../utils/teams/teamsChats";
import { ChatListAvatar } from "../../Feeds/ChatListParts";
import "../../Feeds/LatestMessagesPro.css";
import Coversation from "../../Chat/Coversation";
import useTeamsConnected from "../../../hooks/useTeamsConnected";
import teamsLogo from "../../../Icons/Teams.png";
import { navigateToChatDeeplink } from "../../../helper/chatDeeplink";
import MaterialIcon from "../../../components/MaterialIcon";
import $ from "jquery";
import {
  convertBranchRole,
  convertCapitalLeter,
} from "../../../helper/convertor";
import Geocode from "react-geocode";
import ProjectSettings from "../ProjectSettings";
import { onlyUsername } from "../GroupChat/getUsername";
import MarkdownPreview from "../../../components/MarkdownPreview";
import { BsSearch } from "react-icons/bs";
import ProjectMembers from "../ProjectMembers";
import KjuupPilotChat from "../GroupChat/KjuupPilotChat";
import PilotLogo from "../../../Icons/PilotLogo.png";
import { FaChevronRight } from "react-icons/fa";
import { stripMarkdown, truncateGroupName, stripHtmlToPlainText } from "../../../utils/conversationUtils";
import { getDraftPreviewText } from "../../../utils/draftMessages";
import { translateMessagesBatch } from "../../../utils/translationUtils";
import { getLocaleForLanguage } from "../../../utils/composerUtils";
import RoomToDoTab from "./RoomToDoTab";
import RoomOverview from "./RoomOverview";

Geocode.setApiKey(process.env.REACT_APP_GOOGLE_MAPS_KEY);
Geocode.setLocationType("ROOFTOP");
const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: "rgba(var(--kjuup-accent-rgb), 0.8)",
  };
  return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const hideHorizontalTrack = () => <div style={{ display: 'none' }} />;

const CustomScrollbars = ({ passthrough, overflow = "auto", children, className, ...props }) => {
  if (passthrough) {
    return (
      <div
        className={className}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow,
          overflowX: "hidden",
          minHeight: 0,
          flex: 1,
          ...(overflow === "hidden" ? {} : { scrollbarGutter: "stable" }),
        }}
      >
        {children}
      </div>
    );
  }
  return (
    <Scrollbars
      renderThumbHorizontal={renderThumb}
      renderThumbVertical={renderThumb}
      renderTrackHorizontal={hideHorizontalTrack}
      className={className}
      style={{ width: '100%', height: '100%' }}
      {...props}
    >
      {children}
    </Scrollbars>
  );
};

const CHAT_SECTION_KEYS = {
  DEACTIVATED: 'deactivated_chats',
};

const roomTabActionStyle = (active, _accent = "var(--kjuup-accent)") => ({
  border: "1px solid transparent",
  cursor: "pointer",
  borderRadius: 6,
  padding: "8px 12px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 6,
  fontSize: 14,
  fontWeight: 600,
  whiteSpace: "nowrap",
  margin: 0,
  background: active ? "rgba(var(--kjuup-accent-rgb), 0.16)" : "transparent",
  color: "#737373",
  boxShadow: "none",
});

const MonthSeparator = ({ title }) => (
  <div className="email-attachment-date-header room-month-separator">
    <span className="email-attachment-date-label">
      <MaterialIcon icon="calendar_month" size={14} color="var(--kjuup-accent)" />
      {title}
    </span>
  </div>
);

const RoomMessageTypeIcon = ({ icon }) => (
  <span className="material-symbols-outlined message-type-icon">{icon}</span>
);

const MUTE_BADGE_STYLE = {
  position: "absolute",
  bottom: -2,
  right: -2,
  zIndex: 3,
  fontSize: "14px",
  color: "#737373",
  backgroundColor: "white",
  borderRadius: "50%",
  width: "16px",
  height: "16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontVariationSettings: '"FILL" 0, "wght" 400, "GRAD" 0, "opsz" 14',
  lineHeight: 1,
  cursor: "pointer",
  transition: "transform 0.15s ease",
};

const SectionHeader = ({ title, expanded, onClick, isDeactivated }) => (
  <div
    role="button"
    tabIndex={0}
    onClick={onClick}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    }}
    onMouseDown={(e) => e.stopPropagation()}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      background: 'var(--kjuup-bg)',
      borderTop: '1px solid #f2f2f2',
      borderBottom: '1px solid #f2f2f2',
      padding: '10px',
      margin: 0,
      cursor: 'pointer',
      userSelect: 'none',
      minHeight: 48,
      borderRadius: '10px',
      marginBottom: '8px',
      marginTop: isDeactivated ? '20px' : 0,
      width: '100%',
      boxSizing: 'border-box',
      position: 'relative',
      zIndex: 2,
      touchAction: 'manipulation',
    }}
  >
    <span style={{ fontWeight: 500, fontSize: 16, color: '#737373' }}>{title}</span>
    <img
      src={process.env.PUBLIC_URL + "/assets/img/arrow-right-modern-gray.svg"}
      alt=""
      className="arrow-icon"
      style={{
        width: '16px',
        height: '16px',
        marginLeft: 12,
        transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
        transition: 'transform 0.2s',
        opacity: 1,
        pointerEvents: 'none',
      }}
    />
  </div>
);

const logProjectDetail = (...args) => {
  if (process.env.NODE_ENV !== "production") {
    console.log("[ProjectDetail]", ...args);
  }
};

// Module-level cache of /building/one/:id responses keyed by building id.
// Each entry is { data, fetchedAt } so we can skip the network call on
// subsequent mounts within the freshness window. Cleared on full app reload.
const buildingDetailsCache = new Map();
// How long a cached /building/one/:id response is considered fresh enough
// to serve without re-fetching. The endpoint mostly returns slow-changing
// data (address, room admins, userRole, settings); two minutes is a safe
// trade-off between staleness and avoiding redundant ~1-2s round-trips
// when the user clicks several internal chats of the same building from
// LatestMessages. Anything that mutates this data (room edit, role change,
// join/leave) already dispatches `shouldUpdateProjectDetails`, which patches
// the cache directly via the effect below — so freshness is event-driven,
// not just time-based.
const BUILDING_DETAILS_TTL_MS = 2 * 60 * 1000;
const isBuildingDetailsFresh = (entry) =>
  !!entry &&
  entry.data &&
  entry.fetchedAt &&
  Date.now() - entry.fetchedAt < BUILDING_DETAILS_TTL_MS;

// Module-level cache of /building/:id/user responses. Same freshness window
// as building details: room membership changes slowly, and mutation paths
// (add/remove member) already re-fetch with force.
const buildingMembersCache = new Map();
const isBuildingMembersFresh = (entry) =>
  !!entry &&
  entry.data &&
  entry.fetchedAt &&
  Date.now() - entry.fetchedAt < BUILDING_DETAILS_TTL_MS;

// Build a best-effort initial projectDetails object from the navigating-in
// `project` prop. This lets the header (name, image, theme color, projectNo)
// paint on first frame instead of waiting for the ~1.9s /building/one
// round-trip. Any fields missing here are filled in once the API resolves.
const seedProjectDetailsFromProps = (project) => {
  if (!project) return {};
  return {
    id: project.id,
    name: project.name || project.buildingName,
    image: project.image,
    themeColor: project.themeColor,
    projectNo: project.projectNo,
    street: project.street,
    city: project.city,
    full_address: project.full_address,
    isJoin: project.isJoin !== undefined ? project.isJoin : true,
    isInternal: project.isInternal,
    isDone: project.isDone,
    viewByOwner: !!project.viewByOwner,
    companyId: project.companyId || project.company || project.company_id,
    videoCallEnabled: project.videoCallEnabled,
    buildingProjectType: project.buildingProjectType,
  };
};

function isUnreadEmailFlag(value) {
  return value !== true && value !== 1 && value !== "1";
}

function roomEmailMatchesId(item, key) {
  if (!item || key == null || key === "") return false;
  const k = String(key);
  return String(item.messageId || "") === k || String(item.id || "") === k;
}

function applyMarkedRoomEmailRead(rows, markedRead) {
  if (!markedRead || markedRead.size === 0) return rows;
  return (rows || []).map((item) =>
    item && (markedRead.has(String(item.messageId)) || markedRead.has(String(item.id)))
      ? { ...item, isRead: true }
      : item
  );
}

function shouldShowChatBesideList(fromLatestMsg, pinnedShortcut, isDesktop, isWideScreen) {
  return fromLatestMsg || pinnedShortcut ? isDesktop : isWideScreen;
}

function findOpenedRoomChat({
  projectDocAction,
  selectedRoomEmail,
  roomEmailReplyMode,
  emailInReportPane,
  isFromLatestMsg,
  companionLayout,
  roomListTab,
  chatGroups,
  groupChats,
  user,
  allowedOpenChatId,
  id,
}) {
  const chatListForOpen = (chatGroups && chatGroups.length > 0) ? chatGroups : (groupChats || []);
  const canOpen = !projectDocAction
    && !((selectedRoomEmail || roomEmailReplyMode) && !emailInReportPane)
    && (isFromLatestMsg || companionLayout || (roomListTab !== "email" && roomListTab !== "briefing" && roomListTab !== "todos"))
    && chatListForOpen.length
    && user
    && allowedOpenChatId;
  if (!canOpen) return { openedRoomChat: null, chatListForOpen };
  const openedRoomChat = chatListForOpen.find((chat) =>
    chat.isOpened &&
    String(chat.id) === String(allowedOpenChatId) &&
    (isFromLatestMsg || chat.building === id || String(chat.building) === String(id))
  ) || null;
  return { openedRoomChat, chatListForOpen };
}

// The open Teams chat while nothing else claims the room's message pane (media, an e-mail, the
// member list), else null.
function teamsChatForPane({
  openTeamsChat,
  showMember,
  projectDocAction,
  selectedRoomEmail,
  roomEmailReplyMode,
  emailInReportPane,
}) {
  if (!openTeamsChat || showMember || projectDocAction) return null;
  if ((selectedRoomEmail || roomEmailReplyMode) && !emailInReportPane) return null;
  return openTeamsChat;
}

// Helpers instead of inline `?.` / `||` in the component body: every top-level branch there
// counts towards eslint-plugin-react-hooks@4.2.0's path limit, past which it reports hooks as
// conditional (see the note at its rules-of-hooks disable below).
// "New Teams chat" in the room's Teams tab: a connected Teams account, Kjuup.io, and a room the
// chat can be filed under (not view-only, not completed).
function canStartRoomTeamsChat({ teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails }) {
  return !!teamsConnected && !!hasActiveKjuupIoPlan && !isViewingMode && !(projectDetails && projectDetails.isDone);
}

// What the room list's "+" creates on the current tab: 'chat' and/or 'email'. Alles offers every
// kind the user can create (a menu when more than one); Chat / E-Mail / Teams their own. A Teams
// chat (or a Kjuup + Teams group) is a 'chat': the new-chat picker (AddProjectChatUser) has the
// Teams contacts tab, alone while Kjuup chats are hidden.
function roomCreateChoices({ roomListTab, chatsHiddenPref, emailFeatureEnabled, teamsAvailable }) {
  if (roomListTab === "teams") return teamsAvailable ? ["chat"] : [];
  if (roomListTab === "email") return ["email"];
  if (roomListTab === "chat") return chatsHiddenPref ? ["email"] : ["chat"];
  if (roomListTab !== "all") return [];
  const out = chatsHiddenPref && !teamsAvailable ? [] : ["chat"];
  if (emailFeatureEnabled) out.push("email");
  return out;
}

// What AddProjectChatUser gets for the Teams contacts tab: on with a Teams chat possible here,
// Teams contacts only while Kjuup chats are hidden.
function roomChatTeamsProps({ teamsAvailable, chatsHiddenPref }) {
  return { teamsEnabled: !!teamsAvailable, teamsOnly: !!teamsAvailable && !!chatsHiddenPref };
}

// The "+" bar's labels. With several kinds the bar and its menu name them (Kjuup-Chat /
// E-Mail / Teams-Chat); with one kind the bar says what it creates.
// withTeams: the chat picker offers Teams contacts too (the menu's chat row shows the Teams logo).
function roomCreateLabels(strings, isGerm, choices, withTeams = false) {
  const kinds = {
    chat: strings.room_create_kjuup_chat || "Kjuup chat",
    email: strings.room_create_email || "Email",
    teams: strings.room_create_teams_chat || (isGerm ? "Teams-Chat" : "Teams chat"),
  };
  const single = {
    chat: strings.new_conversation || strings.create_chat || "New chat",
    email: strings.new_email || strings.create_email || "New email",
    teams: strings.teams_new_chat_title || (isGerm ? "Neuer Teams-Chat" : "New Teams chat"),
  };
  const bar = choices.length > 1 ? choices.map((c) => kinds[c]).join(" / ") : single[choices[0]] || single.chat;
  return { ...kinds, bar, withTeams: !!withTeams };
}

// The room's one "Nachrichten" tab: the mixed stream (chats, emails, Teams), the chat list when an
// employee's room is viewed, E-Mail alone when chats are hidden (Kjuup.io preference).
function roomMessagesTab({ isViewingMode, chatsHiddenPref }) {
  if (isViewingMode) return "chat";
  return chatsHiddenPref ? "email" : "all";
}

const ROOM_MESSAGE_TABS = ["all", "chat", "email", "teams"];

function roomIdOfDetail(projectDetails, project) {
  return (projectDetails && projectDetails.id) || (project && project.id) || null;
}

function firstOpenPaneChat(roomChat, teamsChat) {
  return roomChat || teamsChat;
}

function isLeftPaneItemOpen({
  showMember,
  projectDocAction,
  selectedRoomEmail,
  roomEmailReplyMode,
  emailInReportPane,
  openedRoomChat,
}) {
  if (showMember || projectDocAction) return false;
  if ((selectedRoomEmail || roomEmailReplyMode) && !emailInReportPane) return true;
  return !!openedRoomChat;
}

function isEmailInReportPane({
  companionLayout,
  briefingTabActive,
  selectedRoomEmail,
  roomEmailReplyMode,
  roomRightTab,
}) {
  return !!(
    companionLayout
    && briefingTabActive
    && selectedRoomEmail
    && roomEmailReplyMode !== "new"
    && (selectedRoomEmail.systemTag === "daily_briefing" || roomRightTab === "briefing")
  );
}

function ProjectDetailSection(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = $user.get();
  const profile = useSelector((state) => state.profile);
  const subscriptionState = useSelector((state) => state.subscription) || {};
  const {
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
    isKjuupPlusMember,
    stripeUiEnabled,
  } = resolveStripeFlags(profile, subscriptionState);
  const hasActiveKjuupIoPlan = !stripeUiEnabled || !!subscriptionState.active;
  const showCompanyTrialEndedNote = !!subscriptionState.showCompanyTrialEndedNote;
  // Stripe-gated room email tab; hidden when Stripe is disabled for this user.
  const emailFeatureEnabled = canShowEmailCalendarIntegration({
    isKjuupPlusMember,
    hasActiveKjuupIoPlan,
    showCompanyTrialEndedNote,
    stripeFeatureEnabled,
    companyStripeFeatureEnabled,
  });
  const dailyBriefingEnabled = emailFeatureEnabled;
  // Kjuup.io preference "Chats anzeigen" off: the room shows only E-Mail + Medien
  // (no Alles/Chat tabs, create button composes emails only).
  const reduxUserForPrefs = useSelector((state) => state.user);
  const chatsHiddenPref =
    emailFeatureEnabled &&
    chatsHidden(resolveCockpitPersona(profile, subscriptionState, reduxUserForPrefs));
  // Microsoft Teams off in the settings: the room lists no Teams chats.
  const teamsHiddenPref = teamsClientHidden(resolveCockpitPersona(profile, subscriptionState, reduxUserForPrefs));
  const _getChatCallBAck = useCallback(() => getChats(), []);
  const _openChatCallBack = useCallback((id) => handleCloseChat(id), []);
  const _addMemberCallBack = useCallback(() => {
    setAddUserAction({ status: true, id: id });
    setAddChatUserAction({ status: false, id: null });
  }, []);
  const _leaveProjectCallBack = useCallback((id) => handleLeaveProject(id), []);

  const detailDiv = useRef(HTMLDivElement);
  const infWin = useRef(HTMLDivElement);
  const [visible, setVisible] = useState(true);
  const [calcVar, setCalcVar] = useState(0);
  const [animateHide, setAnimateHide] = useState(false);
  const [deleteId, setDeleteId] = useState();
  const [gpId, setDpId] = useState(null);
  const [params, setParams] = useState({
    companyId: "",
    id: "",
    companySelect: false,
  });
  const newGroupData = useSelector(state => state.newGroupData)
  const newGroupJustAddedRef = useRef(false); // Track when a new group was just added
  const newGroupIdToOpenRef = useRef(null); // Store the ID of the newly created group to keep it open
  const pendingCreatedGroupRef = useRef(null); // Newly created group to keep visible if list fetch is stale
  const chatsFetchedForProjectRef = useRef(null); // Track which project's chats have been fetched
  const isGetChatsActiveRef = useRef(false); // Track when getChats() is actively updating to prevent race conditions
  // Chat the user actually opened this visit (click / deeplink / latest-messages).
  // Leftover Redux `isOpened` from a previous visit must not subscribe + mark
  // unread as read just because the room list was opened.
  const userOpenedChatIdRef = useRef(props.groupIdLat || null);
  const activityMessages = useSelector((e) => e.activityMessages);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [activeForward, setActiveForward] = useState(false);
  const [selectedGroupData, setSelectedGroupData] = useState([]);
  const [toggleInfo, setToggleInfo] = useState(false);
  const [allGrps, setGrps] = useState(props.groupChats);
  const { projects } = useSelector((state) => state);
  const { internalProjectsAll } = useSelector((state) => state);
  const activityMessagesReminders = useSelector(
    (e) => e.activityMessagesReminders
  );
  let openGroups = useSelector((e) => e.groupChats);
  const isNewMessage = useSelector((e) => e.isNewMessage);
  const [isKjuup, setIsKjuup] = useState(false);
  useEffect(() => {
    setGrps(props.groupChats);
  }, [props.groupChats]);

  useEffect(() => {
    setIsKjuup(props.project.isInternal);
  }, []);

  // useEffect(()=>{
  //   if(props.project.group){
  //     console.log(props.project.group)
  //   }
  // },[props.project.id])
  const [edit, setEdit] = useState({
    status: false,
    id: null,
    isInternal: props.project.isInternal,
  });
  const [addUserAction, setAddUserAction] = useState({
    status: !!props.addUserAction.openAddProjectWindow,
    id: props.addUserAction.id,
    isInternal: props.project.isInternal,
    cID: props.project.cID,
    addAsMember: props.project.addAsMember,
  });
  const [addChatUserAction, setAddChatUserAction] = useState({
    status: false,
    id: props.addUserAction.id,
    isInternal: props.project.isInternal,
    cID: props.project.cID,
  });
  const [viewLoader, setViewLoader] = useState(false);
  const [show, setShow] = useState(false);
  const [showCompanyDialog, setCompanyDialog] = useState(false);
  const [showMember, setShowMember] = useState(false);
  const [projectDocAction, setProjectDocAction] = useState(false);
  // "Übersicht" (Kjuup.io): the project's tiles and current status instead of the list.
  const [roomOverviewOpen, setRoomOverviewOpen] = useState(false);
  // The user picked a left tab in this room: Übersicht no longer opens by itself.
  const roomOverviewPickedRef = useRef(false);
  // Room "E-Mail" tab: the list lives in the sidebar (where chat groups show)
  // and the selected email opens in the right pane, exactly like a chat group.
  const [projectEmailAction, setProjectEmailAction] = useState(
    () => !props.project?.viewByOwner && chatsHiddenPref
  );
  const [roomEmails, setRoomEmails] = useState([]);
  const [roomEmailsLoading, setRoomEmailsLoading] = useState(false);
  // Room E-Mail sub-tab: "incoming" (Inbox) | "outgoing" (Sent) | "draft" (Drafts)
  const [roomEmailDirection, setRoomEmailDirection] = useState("incoming");
  // Room list kind: regular project mail vs Daily Briefings tab
  const [roomEmailKind, setRoomEmailKind] = useState("email");
  // Left list: All (default) | chat | email. On mobile, todos/briefing still replace the list.
  // Viewing an employee's rooms is read-only: Chat + Media only.
  // Chats hidden (Kjuup.io preference): E-Mail is the only list tab.
  const [roomListTab, setRoomListTab] = useState(() =>
    props.project?.viewByOwner ? "chat" : chatsHiddenPref ? "email" : "all"
  );
  const [returnToRoomTab, setReturnToRoomTab] = useState(null);
  const [showRoomCreateSelector, setShowRoomCreateSelector] = useState(false);
  const roomCreateSelectorRef = useRef(null);
  // Right pane (desktop): todos (default) | briefing. Message overlays slide over this.
  const [roomRightTab, setRoomRightTab] = useState("todos");
  const [roomTodoMounted, setRoomTodoMounted] = useState(false);
  const [todoHeaderHost, setTodoHeaderHost] = useState(null);
  const leftHeaderRef = useRef(null);
  const companionHeaderRef = useRef(null);
  const [messagePaneEl, setMessagePaneEl] = useState(null);
  const [selectedRoomEmail, setSelectedRoomEmail] = useState(null); // full email (with body)
  const [selectedRoomEmailLinkId, setSelectedRoomEmailLinkId] = useState(null);
  const [loadingRoomEmail, setLoadingRoomEmail] = useState(false);
  const [removingRoomEmail, setRemovingRoomEmail] = useState(false);
  const [roomEmailReplyMode, setRoomEmailReplyMode] = useState(null);
  const [assignModalEmail, setAssignModalEmail] = useState(null);
  const [classificationBuildings, setClassificationBuildings] = useState([]);
  const [bookmarkedEmailIds, setBookmarkedEmailIds] = useState(() => {
    try {
      const stored = localStorage.getItem("bookmarkedEmailIds");
      return stored ? new Set(JSON.parse(stored)) : new Set();
    } catch (_) {
      return new Set();
    }
  });
  const [bookmarkedGroupIds, setBookmarkedGroupIds] = useState(() => new Set());
  const locallyUnbookmarkedGroupIdsRef = useRef(new Set());
  const todoRemovedSeq = useSelector((state) => state.todoRemovedSeq);
  const todoRemovedGroupId = useSelector((state) => state.todoRemovedGroupId);
  const todoRemovedEmailId = useSelector((state) => state.todoRemovedEmailId);
  const lastTodoRemovedSeqRef = useRef(todoRemovedSeq || 0);
  const emailAccounts = useSelector((state) => state.emailAccounts) || [];
  const [roomBriefingSaving, setRoomBriefingSaving] = useState(false);
  // Seed with cached + props data so the header paints on the first frame.
  // The /building/one/:id call still fires in getProjectDetails to refresh
  // (unless the cache is fresh — see BUILDING_DETAILS_TTL_MS).
  const [projectDetails, setProjectDetails] = useState(() => {
    const cached = buildingDetailsCache.get(props.project?.id);
    const cachedData = cached && cached.data ? cached.data : null;
    const seed = seedProjectDetailsFromProps(props.project);
    return cachedData ? { ...seed, ...cachedData, viewByOwner: seed.viewByOwner } : seed;
  });
  // Capture deeplink scroll target before deeplinkData is cleared by any code path
  const [deeplinkScrollTarget, setDeeplinkScrollTarget] = useState(null);
  const [isWidthBox, setWidthBox] = useState(0);
  const [allUsers, setAllUsers] = useState([]);
  const [openSetting, setOpenSetting] = useState(false);
  const [storedDraftMessage, setStoredDraftMessage] = useState([]);
  const AllGroupsOfProjects = useSelector((state) => state.AllGroupsOfProjects);
  const shouldUpdateProjectDetails = useSelector((state) => state.shouldUpdateProjectDetails);
  const [alreadyExist, setAlreadyExist] = useState([]);
  const [search, setSearch] = useState("");
  const isDesktop = useSelector((state) => state.isDeskTopResolution);
  const openProjectToggle = useSelector((state) => state.openProjectToggle);
  const openGroupChatToggle = useSelector((state) => state.openGroupChatToggle);
  const openLatestMsgToggle = useSelector((state) => state.openLatestMsgToggle);
  
  // Above 1380px the room, its list, and Aufgaben/Bericht are separate columns.
  // At 1380px and below, an opened room fills the space and those sit in its tabs.
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1380);
  
  useEffect(() => {
    const handleResize = () => {
      setIsWideScreen(window.innerWidth > 1380);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isViewingMode = !!props.project?.viewByOwner;
  const showRoomOverview = !isViewingMode
    && resolveCockpitPersona(profile, subscriptionState, reduxUserForPrefs).persona === PERSONA_IO;
  const companionLayout = isWideScreen && !props.isFromLatestMsg && !isViewingMode;
  const fillRoomColumn = !companionLayout;
  const todosFullbleed = false;
  const todosTabActive = companionLayout ? roomRightTab === "todos" : roomListTab === "todos";
  const briefingTabActive = companionLayout ? roomRightTab === "briefing" : roomListTab === "briefing";

  useEffect(() => {
    if (companionLayout || roomListTab === "todos" || roomRightTab === "todos") {
      setRoomTodoMounted(true);
    }
  }, [companionLayout, roomListTab, roomRightTab]);

  useEffect(() => {
    setRoomTodoMounted(companionLayout || roomListTab === "todos");
    if (companionLayout) setRoomRightTab("todos");
    roomOverviewPickedRef.current = false;
  }, [props.project?.id]);

  // Kjuup.io rooms open on Übersicht, unless they were opened for a chat.
  useEffect(() => {
    if (!showRoomOverview) {
      setRoomOverviewOpen(false);
      return;
    }
    if (roomOverviewPickedRef.current || props.groupIdLat || props.isFromLatestMsg) return;
    setRoomOverviewOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showRoomOverview, props.project?.id]);

  useEffect(() => {
    if (!isViewingMode) return;
    setRoomListTab((tab) => (
      tab === "all" || tab === "email" || tab === "todos" || tab === "briefing" ? "chat" : tab
    ));
    setProjectEmailAction(false);
    setSelectedRoomEmail(null);
    setSelectedRoomEmailLinkId(null);
    setRoomEmailReplyMode(null);
  }, [isViewingMode]);

  useEffect(() => {
    try {
      localStorage.setItem("bookmarkedEmailIds", JSON.stringify([...bookmarkedEmailIds]));
    } catch (_) {}
  }, [bookmarkedEmailIds]);

  useEffect(() => {
    const roomId = projectDetails?.id || props.project?.id;
    if (!roomId) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await callAPI("/todo/userTodo", {}, "POST", {
          search: "",
          limit: 200,
          page: 1,
          onlyBookmarked: true,
          buildingId: roomId,
        });
        if (cancelled || !data?.status || !Array.isArray(data.data)) return;
        const ids = new Set();
        data.data.forEach((todo) => {
          if (todo?.groupId && !todo?.emailMessageId && !locallyUnbookmarkedGroupIdsRef.current.has(String(todo.groupId))) {
            ids.add(todo.groupId);
          }
        });
        setBookmarkedGroupIds(ids);
      } catch (_) { /* bookmark fill is optional */ }
    })();
    return () => { cancelled = true; };
  }, [projectDetails?.id, props.project?.id]);

  useEffect(() => {
    if (!todoRemovedSeq || todoRemovedSeq === lastTodoRemovedSeqRef.current) return;
    lastTodoRemovedSeqRef.current = todoRemovedSeq;
    const groupId = todoRemovedGroupId;
    const emailId = todoRemovedEmailId;
    if (groupId) {
      locallyUnbookmarkedGroupIdsRef.current.add(String(groupId));
      setBookmarkedGroupIds((prev) => {
        if (!prev.has(groupId)) return prev;
        const next = new Set(prev);
        next.delete(groupId);
        return next;
      });
      setChatGroups((prev) =>
        (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: false } : row))
      );
    }
    if (emailId) {
      setBookmarkedEmailIds((prev) => {
        if (!prev.has(String(emailId))) return prev;
        const next = new Set(prev);
        next.delete(String(emailId));
        return next;
      });
    }
  }, [todoRemovedSeq, todoRemovedGroupId, todoRemovedEmailId]);

  // For chats from Latest Messages, use 860px breakpoint (isDesktop)
  // For regular project chats, use 1380px breakpoint (isWideScreen)
  const shouldShowChatSideBySide = shouldShowChatBesideList(
    props.isFromLatestMsg,
    props.isPinnedShortcut,
    isDesktop,
    isWideScreen
  );
  
  const handleShow = async (project) => {
    setShow(true);
    setProjectDetails(project);
  };
  useEffect(() => {
    if (shouldUpdateProjectDetails) {
      const merged = { ...projectDetails, ...shouldUpdateProjectDetails };
      setProjectDetails(merged);
      // Keep the per-room cache in sync with patches so the next open paints
      // the latest data instead of stale cached values. We preserve the
      // existing fetchedAt so the freshness window doesn't reset on every
      // patch (the patch itself is authoritative; the timestamp tracks how
      // long ago we last read from /building/one).
      if (props.project?.id != null) {
        const prevEntry = buildingDetailsCache.get(props.project.id);
        const prevData = prevEntry && prevEntry.data ? prevEntry.data : {};
        buildingDetailsCache.set(props.project.id, {
          data: { ...prevData, ...shouldUpdateProjectDetails },
          fetchedAt: prevEntry ? prevEntry.fetchedAt : Date.now(),
        });
      }
      dispatch({ type: UPDATE_PROJECT_DETAILS, payload: false });
    }
  }, [shouldUpdateProjectDetails]);

  useEffect(() => {
    return () => {
      props.updateGroupChats([])
      setChatGroups([])
      // Reset refs on unmount so next mount starts fresh
      chatsFetchedForProjectRef.current = null;
      newGroupIdToOpenRef.current = null;
      newGroupJustAddedRef.current = false;
      pendingCreatedGroupRef.current = null;
      isGetChatsActiveRef.current = false;
    }
  }, [])
  // console.log(projectDetails)
  const handleClose = () => setShow(false);
  const [users, setUsers] = useState([]);
  const [currentMember, setCurrentMember] = useState(null);
  const [usersBackUp, setUsersBackUp] = useState([]);
  const [searchUser, setSearchUser] = useState("");
  const [members, setMembers] = useState([]);
  const { isGerm, strings, language } = React.useContext(LanguageContext);
  const id = props.project.id;
  const { unSeenAllCount } = useSelector((state) => state);
  const translateRoomAndGroupNames = useSelector((state) => state.translateRoomAndGroupNames);
  const [translatedGroupNames, setTranslatedGroupNames] = useState({});
  const [translatedRoomName, setTranslatedRoomName] = useState('');
  const getProjectDetails = async ({ force = false } = {}) => {
    // Fresh-cache short-circuit: when the user clicks several internal chats
    // of the same building from LatestMessages in quick succession, every
    // mount of ProjectDetail used to re-fire /building/one/:id even though
    // the data is mostly slow-changing (address, room admins, userRole,
    // settings). Skip the network call if a fresh entry exists; building-data
    // events still patch the cache directly via shouldUpdateProjectDetails.
    if (!force) {
      const cached = buildingDetailsCache.get(id);
      if (isBuildingDetailsFresh(cached)) {
        const updatedData = { ...cached.data, viewByOwner: !!props.project.viewByOwner };
        await setProjectDetails(updatedData);
        setViewLoader(false);
        return;
      }
    }

    const { data } = await callAPI(
      `/building/one/${id}`,
      {
        id: id,
      },
      "GET"
    );
    if (data.status) {
      const updatedData = { ...data, viewByOwner: !!props.project.viewByOwner };
      // Cache the response so re-opens of the same room paint instantly
      // and skip the network call within the freshness window.
      buildingDetailsCache.set(id, { data, fetchedAt: Date.now() });
      await setProjectDetails(updatedData);
    } else {
      if (props.project.viewByOwner) {
        const projectDetailsUpdate = { ...projectDetails, isJoin: false };
        await setProjectDetails(projectDetailsUpdate);
      }
    }
    setViewLoader(false);
  };
  useEffect(() => {
    getProjectDetails();
    setChatGroups([]);
    chatsFetchedForProjectRef.current = null;
  }, [props.id]);
  const [companies, setCompanies] = useState([]);
  const companiesLoadedRef = useRef(false);
  const companiesPromiseRef = useRef(null);

  // /company/my is only consumed by the re-join flow (`handleJoin` /
  // `CompanyListDialog`). It used to fire on every room open, costing a
  // ~1.9s round-trip even though the dialog is rarely shown. Now we fetch
  // lazily and de-duplicate concurrent calls.
  const getCompanies = async () => {
    if (companiesLoadedRef.current) return companies;
    if (companiesPromiseRef.current) return companiesPromiseRef.current;
    companiesPromiseRef.current = (async () => {
      try {
        const { data } = await callAPI(`/company/my`, {}, "GET");
        if (data.status) {
          companiesLoadedRef.current = true;
          setCompanies(data.companies);
          return data.companies;
        }
        return [];
      } finally {
        companiesPromiseRef.current = null;
      }
    })();
    return companiesPromiseRef.current;
  };

  useEffect(() => {
    const localStoredMessage = JSON.parse(localStorage.getItem("draftMessage"))
      ? JSON.parse(localStorage.getItem("draftMessage"))
      : [];
    setStoredDraftMessage(localStoredMessage);
    props.updateDraftMessages(localStoredMessage);

    // Apply a warm members cache without hitting the network. A cold cache
    // waits until the members panel / add-user dialog actually opens.
    if (isBuildingMembersFresh(buildingMembersCache.get(id))) {
      getMembers();
    }

    if (toggleInfo) {
      const body = document.querySelector("body");
      const cv = body.clientHeight / 2 - infWin.current.clientHeight - 110;
      setCalcVar(cv);
    }
  }, []);

  useEffect(() => {
    const body = document.querySelector("body");
    if (!toggleInfo) {
      const cv = body.clientHeight / 2 - 110;
      setCalcVar(cv);
    } else {
      const cv = body.clientHeight / 2 - infWin.current.clientHeight - 110;
      setCalcVar(cv);
    }
  }, [toggleInfo]);

  useEffect(() => {
    if (props.updateProjectActionFire) {
      // Forced refresh: this fires after edits / join / leave that mutate
      // the building's state, so the cached entry is stale.
      getProjectDetails({ force: true });
      props.updateProjectAction(false);
    }
  }, [props.updateProjectActionFire]);

  const getProjectName = (name) => getAvatarInitials(name);

  const leaveProject = async (id) => {
    await $crud.confirm({
      title: "",
      textContent: isGerm
        ? "Wollen Sie das Projekt wirklich verlassen? Wenn Sie das Projekt verlassen, verlassen Sie auch alle damit verbundenen Chat Gruppen."
        : "Do you really want to leave the project? When leaving the project you will also leave all associated chat groups.",
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    const { data } = await callAPI(
      `/building/${id}/leave`,
      {
        id: id,
      },
      "GET"
    );
    if (data.status) {
      $crud.notify({
        type: data.status ? "success" : "error",
        message: data.message,
      });
    }
    const updateProjectList = props.openProjects.filter(
      (project) => project.id !== id
    );
    props.updateOpenProjectsList(updateProjectList);
    props.updateProjectAction(true);
    setOpenSetting(false);
  };
  const setParam = async (name, value) => {
    setParams((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  //Handle Re-Join project
  const handleJoin = async (project) => {
    await $crud.confirm({
      title: "",
      textContent: isGerm
        ? `Wollen Sie dem Projekt ${project.name} wirklich wieder beitreten?`
        : `Do you really want to re-join the project ${project.name}?`,
      options: {
        ok: strings.confirm,
        cancel: strings.cancel,
      },
    });
    // Lazily fetch the user's companies on first re-join click. Falls back to
    // the local state if the API has already populated it.
    const fetched = await getCompanies();
    const companyList = (fetched && fetched.length ? fetched : companies) || [];
    if (companyList.length > 1) {
      await setParam("id", project.id);
      setCompanyDialog(true);
    } else if (companyList.length === 1) {
      await submitReJoinSingleCompany(project.id, companyList[0].id);
    } else {
      await submitReJoinWithoutCompany(project.id);
    }
  };

  const submitReJoinSingleCompany = async (project_id, companyId) => {
    const { data } = await callAPI(
      `/building/${params.id}/join`,
      {
        id: project_id,
        companyId: companyId,
      },
      "PUT"
    );
    if (data.status) {
      $crud.notify({
        type: data.status,
        message: data.message,
      });
      getProjectDetails({ force: true });
      props.updateProjectAction(true);
    }
  };

  //Submit RE-join request
  const submitReJoinCompany = async (company) => {
    const { data } = await callAPI(
      `/building/${params.id}/join`,
      {
        id: params.id,
        companyId: company.id,
      },
      "PUT"
    );
    if (data.status) {
      $crud.notify({
        type: data.status,
        message: data.message,
      });
      getProjectDetails({ force: true });
      props.updateProjectAction(true);
    }
  };
  //Submit RE-join request without company
  const submitReJoinWithoutCompany = async (id) => {
    const { data } = await callAPI(`/building/${id}/join`, {}, "PUT");
    if (data.status) {
      $crud.notify({
        type: data.status,
        message: data.message,
      });
      getProjectDetails({ force: true });
      props.updateProjectAction(true);
    }
  };

  const getMembers = async ({ force = false } = {}) => {
    if (!id) return;
    const applyMembers = (data) => {
      let notAccepted = data?.requestNotYetAccepted?.map((item) => {
        return { ...item, requestNotYetAccepted: true, isLeaved: true };
      });
      let _m = [...data.members];
      setCurrentMember(data.currentMember || null);
      setMembers([..._m, ...(notAccepted || [])]);
      return CreateList([..._m, ...(notAccepted || [])]);
    };

    if (!force) {
      const cached = buildingMembersCache.get(id);
      if (isBuildingMembersFresh(cached)) {
        await applyMembers(cached.data);
        return;
      }
    }

    const { data } = await callAPI(`/building/${id}/user`, {}, "GET");
    if (data.status) {
      buildingMembersCache.set(id, { data, fetchedAt: Date.now() });
      await applyMembers(data);
    }
  };

  const CreateList = async (users) => {
    // Collapse duplicate memberships for the same user (prefer admin entry).
    const uniqueUsers = _.uniqBy(
      _.orderBy(users, [(u) => !!u.buldingAdmin], ["desc"]),
      "id"
    );
    const arr = await _.uniqBy(
      uniqueUsers.map((user) => {
        let name = { name: user.lastName.trim()[0].toUpperCase() };
        return name;
      }),
      "name"
    );
    const updatedArr = _.sortBy(arr, ["name"]);
    const usersList = await updatedArr.map((a) => {
      let names = uniqueUsers.filter(
        (u) => u.lastName.trim()[0].toUpperCase() === a.name
      );
      a.names = names;
      return a;
    });
    setUsers(usersList);
    setUsersBackUp(usersList);
  };

  // /building/:id/user is only needed for the members panel and add-user
  // dialogs — not to paint the chat. Fetch lazily so opening a group from
  // Messages doesn't compete with getChat / info for connection slots.
  useEffect(() => {
    if (showMember || addUserAction.status || addChatUserAction.status || openSetting) {
      getMembers();
    }
  }, [showMember, addUserAction.status, addChatUserAction.status, openSetting]);

  useEffect(() => {
    if (allUsers?.length > 0) {
      let filterData = allUsers?.filter(
        (elem) => !members?.find(({ id }) => elem.id === id)
      );
      let allData = _.uniqBy(
        _.orderBy([...filterData, ...members], [(u) => !!u.buldingAdmin], ["desc"]),
        "id"
      );
      const arr = _.uniqBy(
        allData?.map((us) => {
          let name = { name: us?.lastName.trim()[0]?.toUpperCase() };
          return name;
        }),
        "name"
      );
      const updatedArr = _.sortBy(arr, ["name"]);
      const usersList = updatedArr?.map((a) => {
        let names = allData.filter(
          (u) => u.lastName.trim()[0].toUpperCase() === a.name
        );
        a.names = names;
        return a;
      });
      setUsers(usersList);
      setUsersBackUp(usersList);
    }
  }, [allUsers]);

  const hideProject = async () => {
    let tmp = [...activityMessages];
    tmp = tmp.map((e) => {
      return {
        ...e,
        isOpened: e.buildingList == props.id ? false : e.isOpened,
      };
    });
    let tmp1 = [...activityMessagesReminders];
    tmp1 = tmp1.map((e) => {
      return {
        ...e,
        isOpened: e.buildingList == props.id ? false : e.isOpened,
      };
    });
    dispatch({ type: SET_ACTIVITY_MESSAGES, messages: tmp });
    dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: tmp1 });
    const { openProjects, id } = props;
    // setDeleteId(id);
    if (props.isOpenByOwner && openProjects.length == 1) {
      props.isOwnerOpenProject(false);
    }
    const oldData = await openProjects.filter((p) => p.id !== id);
    const updateProjects = props.projects.map((g) => {
      if (g.id === id) {
        return { ...g, isOpened: false };
      } else {
        return { ...g };
      }
    });
    props.updateProjects(updateProjects);
    props.updateOpenProjectsList(oldData);
  };

  const goToRoomOverview = () => {
    setOpenSetting(false);
    if (props.isOpenByOwner && (props.openProjects || []).length === 1) {
      props.isOwnerOpenProject(false);
    }
    const updateProjects = (props.projects || []).map((g) =>
      g.id === props.id ? { ...g, isOpened: false } : g
    );
    props.updateProjects(updateProjects);
    dispatch({ type: SET_ACTIVE_PINNED_ROOM_ID, payload: null });
    dispatch({ type: TOGGLE_LATEST_MSG, payload: false });
    dispatch({ type: TOGGLE_PROJECT, payload: false });
    dispatch({ type: TOGGLE_TODO_VIEW, payload: false });
    dispatch({ type: SET_CHAT_FULLSCREEN, payload: false });
    dispatch({ type: SET_DEEPLINK_DATA, payload: null });
    dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
    dispatch({ type: SET_IN_ACTIVITY, status: false });
    dispatch({ type: SET_OPEN_SIDE_BAR, payload: "project1" });
    dispatch({ type: RIGHT_TOP, rightTop: "project1" });
    dispatch({ type: OPEN_CHATS, openChats: [] });
    props.updateOpenProjectsList([]);
    history.push("/projects");
  };

  const handleEdit = (id) => {
    setEdit({
      status: true,
      id: id,
      isInternal: props.project.isInternal,
    });
  };

  const [chatGroups, setChatGroups] = useState([]);
  const [disableGroup, setDisableGroup] = useState([]);
  const lastProcessedMessageIdRef = useRef(null);
  const isUpdatingFromNewMessageRef = useRef(false);

  useEffect(() => {
    const isOpened = chatGroups.filter((e) => e.isOpened);
    setWidthBox(isOpened.length ? isOpened.length * 400 + 440 : 440);
  }, [chatGroups]);

  useEffect(() => {
    if (!translateRoomAndGroupNames) {
      setTranslatedGroupNames({});
      setTranslatedRoomName('');
      return;
    }
    if (!chatGroups || chatGroups.length === 0) return;

    let cancelled = false;
    const lang = (localStorage.getItem('language') || language || 'en').split('-')[0];

    const translateNames = async () => {
      const batchItems = chatGroups
        .filter((group) => group.name && !group.defaultChatGroup && !group.translatedName)
        .map((group) => ({ id: String(group.id), message: stripMarkdown(group.originalName || group.name) }));
      if (batchItems.length === 0) return;
      const results = await translateMessagesBatch(batchItems, lang);
      if (cancelled) return;
      for (const r of results) {
        const group = chatGroups.find((g) => String(g.id) === String(r.id));
        if (group && r.translatedMessage && r.translatedMessage !== stripMarkdown(group.originalName || group.name)) {
          setTranslatedGroupNames((prev) => prev[group.id] === r.translatedMessage ? prev : { ...prev, [group.id]: r.translatedMessage });
        }
      }
    };

    translateNames();
    return () => { cancelled = true; };
  }, [translateRoomAndGroupNames, chatGroups, language, props.isFromLatestMsg, props.project.buildingName, props.project.name]);

  // Update lastMessage instantly when new message arrives via socket (even if chat is not selected)
  useEffect(() => {
    // Only process if isNewMessage is truthy and has the required data
    if (!isNewMessage || !isNewMessage.group || !isNewMessage.id) return;
    
    const groupId = isNewMessage.group?.id || isNewMessage.groupId;
    const messageId = isNewMessage.id;
    
    // Prevent processing the same message twice
    if (lastProcessedMessageIdRef.current === messageId) return;
    
    // Only process if chatGroups has been initialized
    if (chatGroups.length === 0) return;
    
    // Find the group in chatGroups
    const groupExists = chatGroups.some(g => g.id === groupId);
    if (!groupExists) return;
    
    // Format message text based on messageType (similar to GroupConversation.js handler)
    let messageText = "";
    if (isNewMessage.messageType === "simple") {
      messageText = isNewMessage.message || "";
    } else if (isNewMessage.messageType === "image") {
      messageText = "Image";
    } else if (isNewMessage.messageType === "doc") {
      messageText = "Document";
    } else if (isNewMessage.messageType === "video") {
      messageText = "Video";
    } else if (isNewMessage.messageType === "audio") {
      messageText = "Audio";
    } else {
      messageText = isNewMessage.message || "";
    }
    
      // Only update if we have a valid message text
      if (messageText) {
        // Mark this message as processed to prevent re-processing
        lastProcessedMessageIdRef.current = messageId;
        // Set flag to prevent sync useEffect from interfering
        isUpdatingFromNewMessageRef.current = true;
        
        // Update ONLY local chatGroups state - do NOT update Redux
        // This prevents the sync useEffect from interfering and closing open chats
        // Redux will be updated by GroupConversation when the chat is actually selected
        setChatGroups(prevChatGroups => {
          return prevChatGroups.map(group => {
            if (group.id === groupId) {
              // Check if this message is for the current user (they haven't seen it)
              // unseenChatCount is an array of users who haven't seen the message
              const isMessageForUser = isNewMessage.unseenChatCount?.some?.((u) => u.userId === user?.id) ?? false;
              
              // If chat is closed and message is for this user, increment counter
              // If chat is open, keep counter at 0 (user is viewing it)
              const currentCounter = group.unseenChatCount || 0;
              const newUnseenChatCount = group.isOpened 
                ? 0 // Chat is open, reset counter
                : isMessageForUser 
                  ? currentCounter + 1 // Chat is closed and message is for user, increment
                  : currentCounter; // Chat is closed but message not for user, preserve
              
              return {
                ...group,
                lastMessage: messageText,
                lastMessageType: isNewMessage.messageType || "simple",
                lastMessageDeleted: false,
                lastChatId: messageId || group.lastChatId,
                isTodoBookmarked: false,
                message: messageText,
                messageType: isNewMessage.messageType || "simple",
                messageDate: isNewMessage.createdAt || group.messageDate,
                unseenChatCount: newUnseenChatCount
              };
            }
            return group; // Keep all other groups unchanged, including their isOpened state and counters
          });
        });
        
        setBookmarkedGroupIds((prev) => {
          if (!prev.has(groupId)) return prev;
          const next = new Set(prev);
          next.delete(groupId);
          return next;
        });

        // Clear flag after state update
        setTimeout(() => {
          isUpdatingFromNewMessageRef.current = false;
        }, 0);
      }
  }, [isNewMessage]);

  // Sync chatGroups with Redux groupChats to update lastMessage instantly
  // IMPORTANT: This must preserve isOpened state from local state, never from Redux
  useEffect(() => {
    // Skip sync if we're currently updating from a new message to prevent interference
    if (isUpdatingFromNewMessageRef.current) return;
    
    if (props.groupChats && props.groupChats.length > 0 && chatGroups.length > 0) {
      // Only update if Redux has data and local state exists
      // This ensures lastMessage updates instantly when new messages arrive
      const currentGroupIds = new Set(chatGroups.map(g => g.id));
      const reduxGroupIds = new Set(props.groupChats.map(g => g.id));
      
      // Check if there are any differences in lastMessage
      const hasLastMessageUpdate = props.groupChats.some(reduxGroup => {
        const localGroup = chatGroups.find(g => g.id === reduxGroup.id);
        return localGroup && (
          localGroup.lastMessage !== reduxGroup.lastMessage ||
          localGroup.lastMessageType !== reduxGroup.lastMessageType ||
          localGroup.message !== reduxGroup.message ||
          localGroup.messageType !== reduxGroup.messageType
        );
      });
      
      // Update if there are lastMessage changes and groups match
      if (hasLastMessageUpdate && currentGroupIds.size === reduxGroupIds.size && 
          Array.from(currentGroupIds).every(id => reduxGroupIds.has(id))) {
        // Merge Redux updates with local state, preserving isOpened and other local state
        setChatGroups(prevChatGroups => {
          // Create a map of current isOpened states to preserve them
          const currentOpenedStates = new Map(
            prevChatGroups.map(g => [g.id, g.isOpened])
          );
          
          return prevChatGroups.map(localGroup => {
            const reduxGroup = props.groupChats.find(g => g.id === localGroup.id);
            if (reduxGroup) {
              // CRITICAL: Always preserve isOpened from local state, never from Redux
              // This is the source of truth for which chats are open
              // If a chat is currently open (true), NEVER close it based on Redux
              const currentIsOpened = currentOpenedStates.get(localGroup.id) ?? localGroup.isOpened;
              const preservedIsOpened = currentIsOpened === true ? true : (reduxGroup.isOpened ?? currentIsOpened);
              
              // Only update lastMessage if Redux has a newer/different message
              // Never update isOpened from Redux - it must come from local state
              const newLastMessage = reduxGroup.lastMessage && reduxGroup.lastMessage.trim() 
                ? reduxGroup.lastMessage 
                : localGroup.lastMessage;
              const newMessage = reduxGroup.message && reduxGroup.message.trim() 
                ? reduxGroup.message 
                : localGroup.message;
              
              return {
                ...localGroup,
                // CRITICAL: isOpened MUST come from local state, never Redux
                // If currently open, keep it open regardless of Redux
                isOpened: preservedIsOpened,
                lastMessage: newLastMessage,
                lastMessageType: reduxGroup.lastMessageType || localGroup.lastMessageType,
                lastMessageDeleted: reduxGroup.lastMessageDeleted !== undefined 
                  ? reduxGroup.lastMessageDeleted 
                  : localGroup.lastMessageDeleted,
                message: newMessage,
                messageType: reduxGroup.messageType || localGroup.messageType
              };
            }
            return localGroup;
          });
        });
      }
    }
  }, [props.groupChats, chatGroups.length]);

  const getChats = async (options = {}) => {
    if (projectDetails?.id && projectDetails.id != undefined && projectDetails.id != 'undefined') {
      // Mark that getChats is actively updating to prevent AllGroupsOfProjects from interfering
      isGetChatsActiveRef.current = true;
      logProjectDetail("getChats:start", {
        projectId: projectDetails?.id,
        chatGroupsCount: chatGroups.length,
        deeplinkChatGroupId: deeplinkData?.chatGroupId,
        newGroupId: newGroupIdToOpenRef.current,
        force: !!options.force,
      });
      
      try {
        const { data } = await getBuildingChat({
          buildingId: projectDetails?.id,
          userId: props.project.ownerId ? props.project.ownerId : user?.id,
          lang: isGerm ? "de" : "en",
          viewByOwner: !!props.project.viewByOwner,
          force: !!options.force,
        });
        if (data?.status) {
        // data.groups.unshift({
        //   id: props.project.id,
        //   name: 'Kjuup Pilot',
        //   users: [{ id: user.id }],
        //   isLeave: false,
        //   building: props.project.id,
        //   isPilot: true,
        //   lastMessage: '',
        //   isOpened: false
        // })
        // Only open a chat the user explicitly navigated into this visit.
        // Do NOT reuse leftover `isOpened` from Redux / a previous visit —
        // that subscribed on room entry and cleared unread before the user
        // clicked the chat group.
        const newGroupIdToOpen = newGroupIdToOpenRef.current;
        const deeplinkGroupIdToOpen = deeplinkData?.chatGroupId;
        const groupIdLatToOpen = props.groupIdLat;
        const targetOpenGroupId =
          newGroupIdToOpen ||
          deeplinkGroupIdToOpen ||
          groupIdLatToOpen ||
          userOpenedChatIdRef.current ||
          null;
        if (newGroupIdToOpen) {
          newGroupIdToOpenRef.current = null;
        }
        if (targetOpenGroupId) {
          userOpenedChatIdRef.current = targetOpenGroupId;
        }
        
        let chatsData = await Promise.all(
          data.groups.filter((chat) => !chat.isArchived).map(async (chat) => {
            const isTarget =
              targetOpenGroupId &&
              chat.id &&
              chat.id.toString() === targetOpenGroupId.toString();
            return {
              ...chat,
              isOpened: !!isTarget,
              ...(isTarget ? { unreadCountAtOpen: Number(chat.unseenChatCount) || 0 } : {}),
              unseenChatCount: isTarget ? 0 : chat.unseenChatCount,
            };
          })
        );

        let chatGroupUsers = [];
        if (props.project.viewByOwner) {
          chatGroupUsers = chatsData.map((group) => {
            // isOpened is already set correctly in chatsData above
            if (
              group.isLeave === true &&
              group.users.find(
                (u) => u.id === (props.project.ownerId ?? user?.id)
              )
            ) {
              return { ...group, disabled: true };
            } else {
              return { ...group, disabled: false };
            }
          });
        } else {
          chatGroupUsers = chatsData.map((group) => {
            // isOpened is already set correctly in chatsData above
            if (
              group.isLeave === true &&
              group.users.find(
                (u) => u.id === (props.project.ownerId ?? user?.id)
              )
            ) {
              return {
                ...group,
                disabled: true,
              };
            } else {
              return {
                ...group,
                disabled: false,
              };
            }
          });
        }
        let userData = JSON.parse(localStorage.getItem("user"));
        let filterData = chatGroupUsers
          .sort((a, b) => (a.isLeave === true) - (b.isLeave === true))
          .map((obj) => {
            let chatUser = (obj.users || []).filter(
              u => u.id == userData?.id,
            );
            if (chatUser?.length > 0) {
              return { ...obj }
            }
            else {
              let isAddmin = projectDetails.userRole == "admin" ? true : false
              if ((isAddmin && !projectDetails.isDone)) {
                return { ...obj, onlyView: true }
              }
              else
                return { ...obj }
            }
          });
        let sortedData = _sortArray([...filterData]);
        const pendingCreated = pendingCreatedGroupRef.current;
        if (pendingCreated?.id) {
          const exists = sortedData.some((g) => String(g.id) === String(pendingCreated.id));
          if (exists) {
            pendingCreatedGroupRef.current = null;
          } else {
            const insert = { ...pendingCreated, isOpened: false };
            const defaultIdx = sortedData.findIndex((g) => g.defaultChatGroup);
            if (defaultIdx >= 0) {
              sortedData = [...sortedData];
              sortedData.splice(defaultIdx + 1, 0, insert);
            } else {
              sortedData = [insert, ...sortedData];
            }
          }
        }
        logProjectDetail("getChats:apply", {
          projectId: projectDetails?.id,
          groupsCount: sortedData.length,
          openedGroupIds: sortedData.filter(g => g.isOpened).map(g => g.id),
          targetOpenGroupId
        });
        
        // Mark that we've fetched chats for this project BEFORE dispatching
        // This ensures AllGroupsOfProjects effect will skip when triggered by the dispatch
        chatsFetchedForProjectRef.current = projectDetails?.id;
        
        dispatch({
          type: SET_ALLGROUPS_PROJECTS,
          payload: {
            projectId: projectDetails?.id,
            newGroups: sortedData,
          },
        });
        
        // Also update local state directly to ensure UI updates
        setChatGroups(sortedData);
        setBookmarkedGroupIds((prev) => {
          const next = new Set(prev);
          sortedData.forEach((g) => {
            if (g?.id && g.isTodoBookmarked && !locallyUnbookmarkedGroupIdsRef.current.has(String(g.id))) {
              next.add(g.id);
            }
          });
          return next;
        });
        props.updateGroupChats(sortedData);
        dispatch({ type: GROUP_CHATS, groupChats: sortedData });
        
        // Dismiss loading screen if we were opening a new group, deeplink target, or room-only navigation
        const isRoomOnlyNav = deeplinkData?.roomId && !deeplinkData?.chatGroupId;
        if (newGroupIdToOpen || deeplinkGroupIdToOpen || isRoomOnlyNav) {
          dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
          dispatch({ type: SET_NEW_GROUP_DATA, payload: null });
          if (isRoomOnlyNav) {
            dispatch({ type: SET_DEEPLINK_DATA, payload: null });
          }
          // When deeplinkData has a messageId, preserve it so GroupConversation
          // can read page_no and messageId for scroll-to-message.
          if (deeplinkGroupIdToOpen && !deeplinkData?.messageId) {
            dispatch({ type: SET_DEEPLINK_DATA, payload: null });
          }
          console.log('[ProjectDetail] getChats deeplink handling', {
            deeplinkGroupIdToOpen,
            messageId: deeplinkData?.messageId,
            page_no: deeplinkData?.page_no,
            preserved: !!deeplinkData?.messageId,
          });
        }
        }
      } catch (err) {
        console.warn("[ProjectDetail] getChats failed", err);
      } finally {
        isGetChatsActiveRef.current = false;
      }
    }
  };

  const _sortArray = (res) => {
    let _temp = [...res];
    let _joined = [];
    let _leaved = [];
    for (let obj of _temp) {
      if (obj.defaultChatGroup) {
        _joined.push(obj);
        continue;
      }
      let chatUser = (obj.users || []).filter((u) => u.id == user.id);
      if (chatUser?.length > 0) {
        if (!(chatUser[0]?.isLeave || projectDetails.isDone)) {
          _joined.push(obj);
        } else {
          _leaved.push(obj);
        }
      } else {
        _leaved.push(obj);
      }
    }
    return _joined
      .sort((a, b) => {
        return b.defaultChatGroup - a.defaultChatGroup;
      })
      .concat(_leaved);
  };

  useEffect(() => {
    // Skip when newGroupData is set - the newGroupData flow handles the chat groups
    // This prevents overwriting the isOpened state for newly created chats
    if (newGroupData) {
      return;
    }
    
    // Skip if getChats() is actively updating - let it complete without interference
    if (isGetChatsActiveRef.current) {
      return;
    }
    
    // Skip if chats were already fetched via getChats() API for this project
    // The getChats() data is more accurate/fresh than AllGroupsOfProjects Redux cache
    if (chatsFetchedForProjectRef.current === projectDetails?.id) {
      return;
    }
    
    let ind = AllGroupsOfProjects.findIndex(
      (e) => e.projectId == projectDetails?.id
    );
    if (ind !== -1) {
      // IMPORTANT: Preserve isOpened state from current chatGroups before updating
      const currentOpenedStates = new Map(
        chatGroups.map(g => [g.id, g.isOpened])
      );
      
      let updateChatGroups = [...AllGroupsOfProjects[ind].groups].filter((g) => !g.isArchived);
      let isGroupAlreadyExist = updateChatGroups.find(
        (e) => e.id == props.project.id
      );
      if (!isGroupAlreadyExist) {
        // updateChatGroups.unshift({
        //   id: props.project.id,
        //   name: 'Kjuup Pilot',
        //   users: [{ id: user.id }],
        //   isLeave: false,
        //   building: props.project.id,
        //   isPilot: true,
        //   lastMessage: '',
        //   isOpened: false
        // })
      }
      // setDisableGroup(AllGroupsOfProjects[ind].groups);
      // IMPORTANT: Preserve isOpened state and counters for chats that are already open
      // Only set isOpened: true for the groupIdLat chat, but don't close others
      const currentCounters = new Map(
        chatGroups.map(g => [g.id, g.unseenChatCount])
      );
      
      updateChatGroups = updateChatGroups.map((e) => { 
        // Preserve isOpened from local state only — never from Redux leftover.
        const explicitOpenId = props.groupIdLat || userOpenedChatIdRef.current;
        const preservedIsOpened = currentOpenedStates.get(e.id) === true;
        const finalIsOpened = (explicitOpenId && String(e.id) === String(explicitOpenId)) || preservedIsOpened;
        
        const preservedCounter = currentCounters.get(e.id) ?? e.unseenChatCount;
        const finalCounter = finalIsOpened ? 0 : preservedCounter;
        
        return { 
          ...e, 
          isOpened: finalIsOpened,
          unseenChatCount: finalCounter
        }; 
      });
      setChatGroups(updateChatGroups);
      props.updateGroupChats(updateChatGroups);
    }
  }, [AllGroupsOfProjects, projectDetails, newGroupData]);

  useEffect(() => {
    // Skip if newGroupData is set - that takes priority for opening new chats
    if (newGroupData) return;
    
    // Skip if a new group was just added - don't reopen the old groupIdLat group
    // Don't reset the ref here - let the getChats effect handle that
    if (newGroupJustAddedRef.current) {
      return;
    }
    
    // Skip if getChats is active or just completed - let it handle the chat opening
    if (isGetChatsActiveRef.current) {
      return;
    }
    
    // Skip if there's a chat already open (from getChats or deeplinkData)
    // Only use groupIdLat if no chat is currently open
    const hasOpenChat = chatGroups.some(g => g.isOpened);
    if (hasOpenChat) {
      return;
    }
    
    if (chatGroups.length > 0 && props.groupIdLat) {
      userOpenedChatIdRef.current = props.groupIdLat;
      // IMPORTANT: When opening via groupIdLat, close all OTHER chats to prevent multiple selections
      let groupsData = chatGroups.map((g) => {
        if (g.id === props.groupIdLat) {
          return { ...g, isOpened: true, unreadCountAtOpen: Number(g.unseenChatCount) || 0, unseenChatCount: 0 };
        } else {
          // Close all other chats - only one chat should be open at a time
          return { ...g, isOpened: false };
        }
      });
      logProjectDetail("groupIdLat:open", {
        projectId: projectDetails?.id,
        groupIdLat: props.groupIdLat
      });
      setChatGroups(groupsData);
    }
  }, [props.groupIdLat, newGroupData]);

  const checkExist = async (users) => {
    const getUser = users.find((u) => u.id === user?.id && u.isLeave);
    return !!getUser;
  };

  // Seed chatGroups from data already loaded in LatestMessages. When the user
  // clicks an internal group chat in the latest-messages list, we already have
  // every other group's lastMessage / unseenCount / image / themeColor in
  // memory, so we can paint the building view instantly instead of paying the
  // ~1-2s `/building/:id/chat` round-trip. A silent background refresh runs
  // after a short delay so the full users[] and any cold-cache fields land
  // shortly after.
  const preloadedSeededRef = useRef(false);
  useEffect(() => {
    if (preloadedSeededRef.current) return;
    const seed = props.project?.preloadedChatGroups;
    if (!seed || seed.length === 0) return;
    if (!projectDetails?.id) return;
    preloadedSeededRef.current = true;

    const sorted = _sortArray(seed);
    // Mark as fetched FIRST so the AllGroupsOfProjects and getChats
    // useEffects below skip while we paint from the seed.
    chatsFetchedForProjectRef.current = projectDetails.id;
    setChatGroups(sorted);
    dispatch({
      type: SET_ALLGROUPS_PROJECTS,
      payload: { projectId: projectDetails.id, newGroups: sorted },
    });
    dispatch({ type: GROUP_CHATS, groupChats: sorted });
    if (typeof props.updateGroupChats === "function") {
      props.updateGroupChats(sorted);
    }

    const t = setTimeout(() => {
      // Allow getChats to run; it will refresh chatGroups with the
      // authoritative payload and re-set chatsFetchedForProjectRef itself.
      chatsFetchedForProjectRef.current = null;
      getChats();
    }, 1500);
    return () => clearTimeout(t);
  }, [projectDetails?.id]);

  useEffect(() => {
    // Skip getChats when newGroupData is set - the newGroupData flow will handle opening the chat
    // This prevents a race condition where getChats overwrites the isOpened state
    if (newGroupData) {
      return;
    }

    // Room switch / first load: only keep an explicit chat target. Leftover
    // Redux isOpened from a previous visit must not subscribe on entry.
    if (chatsFetchedForProjectRef.current !== projectDetails?.id) {
      userOpenedChatIdRef.current =
        newGroupIdToOpenRef.current ||
        store.getState().deeplinkData?.chatGroupId ||
        props.groupIdLat ||
        null;
    }
    
    // If a new group was just added, we need to fetch all groups but preserve the selection
    // Reset the ref but remember we need to keep the new group open
    if (newGroupJustAddedRef.current) {
      newGroupJustAddedRef.current = false;
      // Don't skip - let getChats run to fetch all groups
      // newGroupIdToOpenRef.current already contains the group ID to keep selected
    }

    // Opening the create-group UI must not kick off another /building/:id/chat
    // fetch. That in-flight request is reused by refreshChat and would return
    // the list from before the group existed.
    if (addChatUserAction?.status) {
      return;
    }
    
    // Skip if chats have already been fetched for this project (prevents double loading)
    // Only fetch again if we have a new group to open
    if (chatsFetchedForProjectRef.current === projectDetails?.id && !newGroupIdToOpenRef.current) {
      return;
    }
    
    getChats();
    // Note: chatsFetchedForProjectRef is set inside getChats() after the async work completes
  }, [projectDetails?.id, addChatUserAction, newGroupData]);

  // useEffect(() => {
  //   if (props.updateGroupMessage?.message === "") {
  //     getChats();
  //   } else {
  //     let groupsData = chatGroups.map((g) => {
  //       if (g.id === props.updateGroupMessage.group) {
  //         g.lastMessage = props.updateGroupMessage.message;
  //         g.originalMessage = props.updateGroupMessage.message;
  //         g.lastMessageType = props.updateGroupMessage.messageType;
  //         g.lastMessageDeleted = props.updateGroupMessage.lastMessageDeleted;
  //       }
  //       return g;
  //     });
  //     Promise.resolve().then(() => {
  //       setChatGroups(groupsData);
  //     });
  //   }
  // }, [props.updateGroupMessage]);

  useEffect(() => {
    setStoredDraftMessage(props.draftMessages);
  }, [props.draftMessages]);

  const setDraftMessage = (message, group) => {
    // Guard: ensure group is defined
    if (!group || !group.id) {
      console.warn("[ProjectDetail] setDraftMessage: group is undefined or missing id");
      return;
    }
    
    message = message.trim();
    if (message) {
      const msgObject = {
        userId: user?.id,
        message: message,
        messageType: "simple",
        group: group.id,
      };

      // Guard: ensure draftMessages is an array
      let allMessages = props.draftMessages || [];
      const foundIndex = allMessages.findIndex(
        (msg) => msg && msg.userId === user?.id && msg.group === group.id
      );
      if (foundIndex > -1) {
        allMessages[foundIndex] = {
          ...allMessages[foundIndex],
          message: message,
        };
      } else {
        allMessages = [...allMessages, msgObject];
      }
      localStorage.setItem("draftMessage", JSON.stringify(allMessages));
      if (props.updateDraftMessages) {
        props.updateDraftMessages(allMessages);
      }
    }
  };

  // ── Room "E-Mail" tab ────────────────────────────────────────────────────
  // Ids we have already marked read in this session. Also used to re-apply the
  // read state over a reloaded list: the BE can still report them as unread if
  // the list request overlaps the PATCH, and a resurrected row would both show
  // the unread dot again and put the section badge back.
  const markedRoomEmailReadIdsRef = useRef(new Set());
  const roomEmailDetailRef = useRef(null);
  const roomEmailReplyModeRef = useRef(null);
  roomEmailReplyModeRef.current = roomEmailReplyMode;

  const toggleRoomBriefing = async (next) => {
    const buildingId = projectDetails?.id || props.project?.id;
    if (!buildingId || roomBriefingSaving) return;
    const previous = !!projectDetails?.dailyBriefingEnabled;
    setProjectDetails((prev) => ({ ...prev, dailyBriefingEnabled: next }));
    setRoomBriefingSaving(true);
    try {
      const { data } = await callAPI(`/building/dailyBriefing`, {}, "PUT", {
        buildingList: buildingId,
        dailyBriefingEnabled: next,
      });
      if (!data?.status) {
        setProjectDetails((prev) => ({ ...prev, dailyBriefingEnabled: previous }));
        $crud.notify({
          type: "error",
          message: data?.message || strings.something_went_wrong,
        });
      }
    } catch (err) {
      setProjectDetails((prev) => ({ ...prev, dailyBriefingEnabled: previous }));
    } finally {
      setRoomBriefingSaving(false);
    }
  };

  // Load the whole emails classified into this room (reference-only). The list
  // renders in the sidebar; opening one shows the reader in the right pane.
  const loadRoomEmails = async (buildingId, direction = roomEmailDirection, kind = roomEmailKind) => {
    if (!buildingId) return;
    setRoomEmailsLoading(true);
    try {
      const fetchRows = async (dir, listKind) => {
        const res = await callAPI(
          `/email/projects/${buildingId}/emails?direction=${dir}&kind=${listKind}`,
          {},
          "GET"
        );
        const data = res?.data || res;
        let rows = data && data.status && Array.isArray(data.data) ? data.data : [];
        if (listKind === "briefing") {
          rows = rows.filter((item) => item && item.systemTag === "daily_briefing");
        }
        return rows;
      };
      let rows = [];
      if (kind === "all") {
        // All stream: incoming mail only. Reports stay on the Bericht tab.
        // Sent mail belongs under E-Mail → Gesendet, not the mixed room timeline.
        rows = (await fetchRows("incoming", "email")).filter(
          (item) => item && item.systemTag !== "daily_briefing"
        );
      } else {
        const dir = direction === "outgoing" || direction === "draft" ? direction : "incoming";
        const listKind = kind === "briefing" ? "briefing" : "email";
        rows = await fetchRows(dir, listKind);
      }
      const nextRows = applyMarkedRoomEmailRead(rows, markedRoomEmailReadIdsRef.current);
      setRoomEmails(nextRows);
      setBookmarkedEmailIds((prev) => {
        const next = new Set(prev);
        nextRows.forEach((item) => {
          if (!item || !item.isTodoBookmarked) return;
          const id = item.messageId || item.id;
          if (id) next.add(String(id));
        });
        return next;
      });
    } catch (e) {
      setRoomEmails([]);
    } finally {
      setRoomEmailsLoading(false);
    }
  };

  // Microsoft Teams chats the user filed under this room (their own only): the "Teams" tab and
  // rows under "Alles". Reloaded when a chat is assigned or removed anywhere in the app.
  const [roomTeamsChats, setRoomTeamsChats] = useState([]);
  // The Teams chat open in the room's message pane (a teamsChatEntry), or null. It opens like a
  // room chat but in the room-less chat pane (Coversation, Teams mode): it has no room membership.
  const [openTeamsChat, setOpenTeamsChat] = useState(null);
  // A connected Teams account: the room's new-chat picker gets its "Teams contacts" tab.
  const teamsConnected = useTeamsConnected(teamsHiddenPref);
  const roomTeamsRoomId = roomIdOfDetail(projectDetails, props.project);
  useEffect(() => {
    setOpenTeamsChat(null);
  }, [roomTeamsRoomId]);
  useEffect(() => {
    if (isViewingMode || !roomTeamsRoomId || teamsHiddenPref) {
      setRoomTeamsChats([]);
      return undefined;
    }
    let cancelled = false;
    const load = () => listTeamsProjectChats(roomTeamsRoomId).then((list) => {
      if (!cancelled) setRoomTeamsChats(list);
    });
    load();
    window.addEventListener(TEAMS_PROJECT_EVENT, load);
    return () => {
      cancelled = true;
      window.removeEventListener(TEAMS_PROJECT_EVENT, load);
    };
  }, [roomTeamsRoomId, isViewingMode, teamsHiddenPref]);
  // The last chat left the room while its tab was open: back to Alles. The tab stays while a new
  // Teams chat can be started from it.
  useEffect(() => {
    if (roomListTab !== "teams" || roomTeamsChats.length > 0) return;
    if (canStartRoomTeamsChat({ teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails })) return;
    setRoomListTab(chatsHiddenPref ? "email" : "all");
  }, [roomListTab, roomTeamsChats.length, chatsHiddenPref, teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails]);

  // Fetch room emails for All / E-Mail. Briefings on desktop live in the right pane.
  useEffect(() => {
    if (!emailFeatureEnabled || !projectDetails?.id) return;
    if (roomListTab === "all") {
      loadRoomEmails(projectDetails.id, "incoming", "all");
    } else if (roomListTab === "email") {
      loadRoomEmails(projectDetails.id, roomEmailDirection, "email");
    } else if (!companionLayout && roomListTab === "briefing") {
      loadRoomEmails(projectDetails.id, "incoming", "briefing");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomListTab, projectDetails?.id, roomEmailDirection, emailFeatureEnabled, dailyBriefingEnabled, companionLayout]);

  // Ensure email accounts are available for Reply / Forward from the room reader.
  useEffect(() => {
    if (!emailFeatureEnabled) return;
    if (roomListTab === "chat") return;
    if (emailAccounts.length > 0) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await callAPI("/email/accounts", {}, "GET");
        if (cancelled) return;
        let accounts = [];
        if (Array.isArray(data)) accounts = data;
        else if (data?.accounts && Array.isArray(data.accounts)) accounts = data.accounts;
        dispatch({ type: SET_EMAIL_ACCOUNTS, payload: accounts });
      } catch (_) { /* ignore */ }
    })();
    return () => { cancelled = true; };
  }, [roomListTab, emailAccounts.length, dispatch, emailFeatureEnabled]);

  // Deep-link: when this room was opened from an email's project tag, the parent
  // stashed { buildingId, emailId } in Redux `pendingEmailOpen`. If it targets
  // this room, switch to the E-Mail section and auto-open that email once the
  // list loads, then clear the flag.
  const pendingEmailOpen = useSelector((s) => s.pendingEmailOpen);
  const consumedInitialEmailRef = useRef(false);

  const markRoomEmailAsRead = async (messageId, wasUnread, options = {}) => {
    if (!messageId || wasUnread === false) return;
    const keys = [messageId, options.altId].filter(Boolean).map((id) => String(id));
    if (keys.some((k) => markedRoomEmailReadIdsRef.current.has(k))) return;
    keys.forEach((k) => markedRoomEmailReadIdsRef.current.add(k));
    const isBriefing = !!(options.isBriefing || roomEmailKind === "briefing");
    const buildingId = options.buildingId || projectDetails?.id || props.project?.id;
    const isInternal = options.isInternal != null ? !!options.isInternal : !!props.project?.isInternal;
    const markRowRead = (it) => (keys.some((k) => roomEmailMatchesId(it, k)) ? { ...it, isRead: true } : it);
    setRoomEmails((prev) => (prev || []).map(markRowRead));
    setSelectedRoomEmail((prev) => (prev && keys.some((k) => roomEmailMatchesId(prev, k)) ? { ...prev, isRead: true } : prev));
    dispatch(
      isBriefing
        ? { type: DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT, buildingId, isInternal }
        : { type: DECREMENT_UNSEEN_EMAIL_COUNT }
    );
    invalidateBadgeCount();
    let marked = false;
    try {
      const { data } = await callAPI(`/email/messages/${messageId}`, {}, "PATCH", { isRead: true });
      if (data?.status === false) throw new Error((data && data.message) || "rejected");
      marked = true;
    } catch (_) {
      if (!isBriefing) {
        keys.forEach((k) => markedRoomEmailReadIdsRef.current.delete(k));
        setRoomEmails((prev) =>
          (prev || []).map((it) => (keys.some((k) => roomEmailMatchesId(it, k)) ? { ...it, isRead: false } : it))
        );
        setSelectedRoomEmail((prev) =>
          prev && keys.some((k) => roomEmailMatchesId(prev, k)) ? { ...prev, isRead: false } : prev
        );
        dispatch({ type: INCREMENT_UNSEEN_EMAIL_COUNT });
      }
    }
    if (isBriefing) return;
    if (!marked) return;
    try {
      const { data: badge } = await getBadgeCount({ force: true });
      if (badge && badge.status) dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: badge });
    } catch (_) { /* optimistic counts stand until the next refresh */ }
  };

  useEffect(() => {
    if (!emailFeatureEnabled) {
      setProjectEmailAction(false);
      // Leave Nachrichten / Aufgaben as they are (no emails in the stream); only leave Kjuup.io tabs.
      setRoomListTab((tab) => (
        tab === "email" || tab === "briefing" ? roomMessagesTab({ isViewingMode, chatsHiddenPref: false }) : tab
      ));
      return;
    }
    if (
      pendingEmailOpen &&
      projectDetails?.id &&
      String(pendingEmailOpen.buildingId) === String(projectDetails.id)
    ) {
      setRoomListTab("all");
      setProjectEmailAction(false);
      roomOverviewPickedRef.current = true;
      setRoomOverviewOpen(false);
      consumedInitialEmailRef.current = false;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingEmailOpen, projectDetails?.id, emailFeatureEnabled]);

  useEffect(() => {
    if (!emailFeatureEnabled) return;
    if (!pendingEmailOpen) return;
    if (String(pendingEmailOpen.buildingId) !== String(projectDetails?.id)) return;
    if (roomListTab === "email" || roomListTab === "briefing") {
      if (!projectEmailAction) return;
    }
    if (roomEmailsLoading) return;
    if (!Array.isArray(roomEmails)) return;
    if (consumedInitialEmailRef.current) return;
    const targetId = pendingEmailOpen.emailId;
    if (targetId && roomEmails.length > 0) {
      const match = roomEmails.find((it) => String(it.messageId) === String(targetId));
      if (match) {
        consumedInitialEmailRef.current = true;
        openRoomEmail(match);
        dispatch({ type: SET_PENDING_EMAIL_OPEN, payload: null });
        return;
      }
    }
    // Emails have loaded; clear so it doesn't re-trigger on later visits.
    dispatch({ type: SET_PENDING_EMAIL_OPEN, payload: null });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingEmailOpen, roomListTab, projectEmailAction, roomEmails, roomEmailsLoading, projectDetails?.id]);

  const openRoomEmail = async (item) => {
    if (!item) return;
    // Keep an in-progress compose open so switching list entries can show
    // the second bottom tab instead of prompting to discard the draft.
    if (!roomEmailReplyModeRef.current) {
      const allowed = await leaveRoomComposeIfNeeded();
      if (!allowed) return;
    }
    // Opening an email should close the chat/media panes, mirroring openChat.
    setProjectDocAction(false);
    // Close any open chat group so only the email reader shows on the right.
    const closedGroups = chatGroups.map((g) => (g.isOpened ? { ...g, isOpened: false } : g));
    setChatGroups(closedGroups);
    props.updateGroupChats(closedGroups);

    if (!roomEmailReplyModeRef.current) {
      setRoomEmailReplyMode(null);
    }
    setSelectedRoomEmailLinkId(item.id);
    setLoadingRoomEmail(true);
    const roomLink = projectDetails?.id
      ? [{ id: projectDetails.id, name: projectDetails.name || props.project?.name || "" }]
      : [];
    const roomAccountId = item.emailAccount || item.accountId || item.emailAccountId || null;
    const isBriefing = roomEmailKind === "briefing" || item.systemTag === "daily_briefing";
    const wasUnread = isUnreadEmailFlag(item.isRead);
    setSelectedRoomEmail({
      id: item.messageId || item.id,
      messageId: item.messageId || item.id,
      subject: item.subject,
      fromAddress: item.fromAddress,
      toAddresses: item.toAddresses,
      receivedAt: item.receivedAt,
      isRead: wasUnread ? true : item.isRead,
      linkedProjects: roomLink,
      direction: item.direction || roomEmailDirection,
      emailAccount: roomAccountId,
      __accountId: roomAccountId,
      systemTag: item.systemTag || (isBriefing ? "daily_briefing" : null),
    });
    if (wasUnread) {
      markRoomEmailAsRead(item.messageId || item.id, true, {
        isBriefing,
        altId: item.id,
        buildingId: projectDetails?.id || props.project?.id,
        isInternal: !!props.project?.isInternal,
      });
    }
    try {
      const openParams = {};
      if (roomAccountId) openParams.accountId = roomAccountId;
      const isDraft = roomEmailDirection === "draft"
        || item.direction === "draft"
        || item.folder === "DRAFT"
        || (Array.isArray(item.labels) && item.labels.includes("DRAFT"));
      if (isDraft || item.direction === "outgoing" || roomEmailDirection === "outgoing") {
        openParams.folder = isDraft ? "DRAFT" : "SENT";
      }
      const res = await callAPI(`/email/messages/${item.messageId || item.id}`, openParams, "GET");
      const data = res?.data || res;
      if (data && data.status && data.message) {
        const msg = data.message;
        // Ensure reply from the room reader inherits this project.
        const linked = Array.isArray(msg.linkedProjects) && msg.linkedProjects.length > 0
          ? msg.linkedProjects
          : roomLink;
        const msgAccountId = msg.emailAccount || msg.accountId || msg.emailAccountId || item.emailAccount || null;
        setSelectedRoomEmail({
          ...msg,
          linkedProjects: linked,
          isRead: true,
          emailAccount: msgAccountId,
          __accountId: msgAccountId,
          systemTag: msg.systemTag || item.systemTag || (isBriefing ? "daily_briefing" : null),
        });
        if (wasUnread || isUnreadEmailFlag(msg.isRead)) {
          markRoomEmailAsRead(msg.id || item.messageId || item.id, true, {
            isBriefing: isBriefing || msg.systemTag === "daily_briefing",
            altId: item.messageId || item.id,
            buildingId: projectDetails?.id || props.project?.id,
            isInternal: !!props.project?.isInternal,
          });
        }
      }
      if (isBriefing && wasUnread) {
        try {
          const { data: badge } = await getBadgeCount({ force: true });
          if (badge && badge.status) dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: badge });
        } catch (_) { /* optimistic counts stand */ }
      }
    } catch (e) {
      $crud.notify({ type: "error", message: strings.something_went_wrong || "Something went wrong" });
    } finally {
      setLoadingRoomEmail(false);
    }
  };

  const leaveRoomComposeIfNeeded = useCallback(async () => {
    if (!roomEmailReplyModeRef.current) return true;
    if (!roomEmailDetailRef.current?.requestCloseCompose) {
      setRoomEmailReplyMode(null);
      return true;
    }
    return !!(await roomEmailDetailRef.current.requestCloseCompose());
  }, []);

  const closeRoomEmail = async () => {
    const allowed = await leaveRoomComposeIfNeeded();
    if (!allowed) return false;
    setSelectedRoomEmail(null);
    setSelectedRoomEmailLinkId(null);
    setRoomEmailReplyMode(null);
    restoreReturnTab();
    return true;
  };

  const openChatFromNotificationEmail = (params) => {
    if (!params || !params.chatGroupId) return;
    closeRoomEmail();
    const thisRoomId = projectDetails?.id || props.project?.id;
    const inThisRoom = (chatGroups || []).some(
      (g) => g && String(g.id) === String(params.chatGroupId)
    );
    if (inThisRoom || (params.roomId && thisRoomId && String(params.roomId) === String(thisRoomId))) {
      dispatch({
        type: SET_DEEPLINK_DATA,
        payload: {
          chatGroupId: params.chatGroupId,
          messageId: params.messageId,
          roomId: params.roomId || thisRoomId,
          companyId: params.companyId,
          isInternal: !!(params.companyId || params.isInternal || props.project?.isInternal),
          page_no: params.page_no || 1,
        },
      });
      return;
    }
    navigateToChatDeeplink({ dispatch, history, ...params });
  };

  const removeRoomEmail = async (linkId, item) => {
    const id = linkId || item?.messageId || item?.id || selectedRoomEmailLinkId;
    if (removingRoomEmail || !id) return;
    try {
      await $crud.confirm({
        title: "",
        textContent: (roomEmailKind === "briefing" || item?.systemTag === "daily_briefing")
          ? (strings.email_room_briefing_remove_confirm || "Willst du das Tagebriefing wirklich entfernen?")
          : (strings.email_room_remove_confirm || "Remove this email from the project?"),
        options: { ok: strings.ok || "OK", cancel: strings.cancel || "Cancel" },
      });
    } catch (_) {
      return;
    }
    setRemovingRoomEmail(true);
    try {
      await callAPI(`/email/project-messages/${id}`, {}, "DELETE");
      $crud.notify({
        type: "success",
        message: (roomListTab === "briefing" || item?.systemTag === "daily_briefing")
          ? (strings.email_room_briefing_removed || strings.email_room_removed || "Report removed")
          : (strings.email_room_removed || "Email removed from project"),
      });
      if ((roomListTab === "briefing" || item?.systemTag === "daily_briefing") && item && item.isRead !== true && item.isRead !== 1) {
        dispatch({
          type: DECREMENT_UNSEEN_DAILY_BRIEFING_COUNT,
          buildingId: projectDetails?.id || props.project?.id,
          isInternal: !!props.project?.isInternal,
        });
      }
      if (String(selectedRoomEmailLinkId) === String(id)) {
        closeRoomEmail();
      }
      await loadRoomEmails(
        projectDetails?.id,
        roomListTab === "all" ? "incoming" : roomEmailDirection,
        roomListTab === "all" ? "all" : (roomListTab === "briefing" ? "briefing" : "email")
      );
    } catch (e) {
      $crud.notify({ type: "error", message: strings.something_went_wrong || "Something went wrong" });
    } finally {
      setRemovingRoomEmail(false);
    }
  };

  const roomEmailMessageId = (item) =>
    item?.messageId || item?.id || item?._id || item?.providerMessageId;

  const isRoomEmailBookmarked = (item) => {
    if (!item) return false;
    if (item.isTodoBookmarked) return true;
    const ids = [item.messageId, item.id, item._id, item.providerMessageId]
      .filter(Boolean)
      .map((id) => String(id));
    return ids.some((id) => bookmarkedEmailIds.has(id));
  };

  const createTodoFromRoomEmail = async (item) => {
    const emailId = roomEmailMessageId(item);
    if (!emailId) return;
    const summary = getEmailListPreview(item, !!user?.emailSummaryPreviewEnabled)
      || firstEmailSentence(item?.bodyText || item?.snippet || item?.subject)
      || stripHtmlToPlainText(item?.subject || "").replace(/\s+/g, " ").trim()
      || strings.email_no_subject || "(No subject)";
    setBookmarkedEmailIds((prev) => new Set(prev).add(String(emailId)));
    setRoomEmails((prev) =>
      (prev || []).map((row) =>
        roomEmailMatchesId(row, emailId) ? { ...row, isTodoBookmarked: true } : row
      )
    );
    setSelectedRoomEmail((prev) =>
      prev && roomEmailMatchesId(prev, emailId) ? { ...prev, isTodoBookmarked: true } : prev
    );
    const tempId = `pending-bookmark-email-${emailId}-${Date.now()}`;
    const roomId = projectDetails?.id || props.project?.id || undefined;
    beginExternalBookmarkTodo(dispatch, {
      tempId,
      emailId: String(emailId),
      roomId,
      strings,
    });
    try {
      const { data } = await callAPI("/todo/manualTodoCreate", {}, "POST", {
        emailId: String(emailId),
        summary,
        messageText: item?.bodyText || item?.snippet || summary,
        roomId,
      });
      if (data && data.status) {
        finishBookmarkTodo(dispatch, { tempId, todo: data.data || null });
        $crud.notify({
          type: "success",
          message: strings.todo_bookmarked || "Aufgabe wurde vorgemerkt",
        });
      } else {
        setBookmarkedEmailIds((prev) => {
          const next = new Set(prev);
          next.delete(String(emailId));
          return next;
        });
        setRoomEmails((prev) =>
          (prev || []).map((row) =>
            roomEmailMatchesId(row, emailId) ? { ...row, isTodoBookmarked: false } : row
          )
        );
        failBookmarkTodo(dispatch, { tempId });
        $crud.notify({
          type: "error",
          message: (data && data.message) || strings.todo_creation_failed || "Failed to create todo",
        });
      }
    } catch (_) {
      setBookmarkedEmailIds((prev) => {
        const next = new Set(prev);
        next.delete(String(emailId));
        return next;
      });
      setRoomEmails((prev) =>
        (prev || []).map((row) =>
          roomEmailMatchesId(row, emailId) ? { ...row, isTodoBookmarked: false } : row
        )
      );
      failBookmarkTodo(dispatch, { tempId });
      $crud.notify({
        type: "error",
        message: strings.todo_creation_failed || "Failed to create todo",
      });
    }
  };

  const removeRoomEmailBookmark = async (item) => {
    const emailId = roomEmailMessageId(item);
    if (!emailId) return;
    setBookmarkedEmailIds((prev) => {
      const next = new Set(prev);
      next.delete(String(emailId));
      return next;
    });
    setRoomEmails((prev) =>
      (prev || []).map((row) =>
        roomEmailMatchesId(row, emailId) ? { ...row, isTodoBookmarked: false } : row
      )
    );
    setSelectedRoomEmail((prev) =>
      prev && roomEmailMatchesId(prev, emailId) ? { ...prev, isTodoBookmarked: false } : prev
    );
    try {
      const { data } = await callAPI("/todo/removeBookmark", {}, "POST", { emailId: String(emailId) });
      if (data && data.status && data.kept) {
        setBookmarkedEmailIds((prev) => new Set(prev).add(String(emailId)));
        setRoomEmails((prev) =>
          (prev || []).map((row) =>
            roomEmailMatchesId(row, emailId) ? { ...row, isTodoBookmarked: true } : row
          )
        );
        $crud.notify({
          type: "info",
          message: strings.bookmark_already_todo || "Diese Aufgabe wurde bereits bearbeitet und bleibt bestehen",
        });
      } else if (data && data.status && data.removed) {
        $crud.notify({
          type: "success",
          message: strings.bookmark_removed || "Vorgemerkte Aufgabe entfernt.",
        });
        dispatch({ type: REFRESH_TODO_LIST });
      }
    } catch (_) {
      setBookmarkedEmailIds((prev) => new Set(prev).add(String(emailId)));
      setRoomEmails((prev) =>
        (prev || []).map((row) =>
          roomEmailMatchesId(row, emailId) ? { ...row, isTodoBookmarked: true } : row
        )
      );
    }
  };

  const toggleRoomEmailBookmark = (item) => {
    if (isRoomEmailBookmarked(item)) removeRoomEmailBookmark(item);
    else createTodoFromRoomEmail(item);
  };

  const roomChatLastMessageSummary = (group) => {
    const raw = String(group?.lastMessage || group?.message || "").trim();
    if (!raw) return "";
    const clean = cleanChatMessageText(raw);
    return oneSentenceMessageSummary(clean) || clean.slice(0, 180);
  };

  const isRoomChatBookmarked = (group) =>
    !!(group?.id && bookmarkedGroupIds.has(group.id));

  const canBookmarkRoomChat = (group) => {
    if (!group || group.isPilot || activeForward) return false;
    if (group.lastMessageDeleted) return false;
    return !!(group.lastMessage || group.lastChatId);
  };

  const createTodoFromRoomChat = async (group) => {
    const groupId = group?.id;
    if (!groupId) return;
    const roomId = projectDetails?.id || props.project?.id || undefined;
    const tempId = `pending-bookmark-group-${groupId}-${Date.now()}`;
    locallyUnbookmarkedGroupIdsRef.current.delete(String(groupId));
    setBookmarkedGroupIds((prev) => new Set(prev).add(groupId));
    setChatGroups((prev) =>
      (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: true } : row))
    );
    beginExternalBookmarkTodo(dispatch, {
      tempId,
      chatId: group.lastChatId || null,
      groupId,
      roomId,
      strings,
    });

    let lastChatId = group.lastChatId;
    const messageText = cleanChatMessageText(group?.lastMessage || group?.message || "");
    if (!lastChatId) {
      try {
        const building = group.building || projectDetails?.id || props.project?.id;
        let url = `/group/${groupId}/getChat?page=1&limit=1`;
        if (building) url += `&building=${building}`;
        const { data: chatData } = await callAPI(url, {}, "GET");
        const last = Array.isArray(chatData?.chatHistory) ? chatData.chatHistory[0] : null;
        if (last?.id) lastChatId = last.id;
        if (lastChatId) {
          setChatGroups((prev) =>
            (prev || []).map((row) => (row.id === groupId ? { ...row, lastChatId } : row))
          );
        }
      } catch (_) { /* group-only bookmark still works */ }
    }
    if (!messageText && !lastChatId) {
      failBookmarkTodo(dispatch, { tempId, chatId: lastChatId });
      return;
    }
    try {
      const payload = {
        messageText: messageText || "",
        group: groupId,
        roomId,
      };
      if (lastChatId) payload.chat = lastChatId;
      const { data } = await callAPI("/todo/manualTodoCreate", {}, "POST", payload);
      if (data && data.status && (data.data?.id || data.data?.todoId)) {
        finishBookmarkTodo(dispatch, { tempId, chatId: lastChatId, groupId, roomId, todo: data.data || null });
        $crud.notify({
          type: "success",
          message: strings.todo_bookmarked || "Aufgabe wurde vorgemerkt",
        });
      } else {
        setBookmarkedGroupIds((prev) => {
          const next = new Set(prev);
          next.delete(groupId);
          return next;
        });
        setChatGroups((prev) =>
          (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: false } : row))
        );
        failBookmarkTodo(dispatch, { tempId, chatId: lastChatId });
        $crud.notify({
          type: "error",
          message: (data && data.message) || strings.todo_creation_failed || "Failed to create todo",
        });
      }
    } catch (_) {
      setBookmarkedGroupIds((prev) => {
        const next = new Set(prev);
        next.delete(groupId);
        return next;
      });
      setChatGroups((prev) =>
        (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: false } : row))
      );
      failBookmarkTodo(dispatch, { tempId, chatId: lastChatId });
      $crud.notify({
        type: "error",
        message: strings.todo_creation_failed || "Failed to create todo",
      });
    }
  };

  const removeRoomChatBookmark = async (group) => {
    const groupId = group?.id;
    if (!groupId) return;
    locallyUnbookmarkedGroupIdsRef.current.add(String(groupId));
    setBookmarkedGroupIds((prev) => {
      const next = new Set(prev);
      next.delete(groupId);
      return next;
    });
    setChatGroups((prev) =>
      (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: false } : row))
    );
    dispatch({ type: TODO_ITEM_REMOVED, groupId, chatId: group.lastChatId || null });
    try {
      const payload = { groupId };
      if (group.lastChatId) payload.chatId = group.lastChatId;
      const { data } = await callAPI("/todo/removeBookmark", {}, "POST", payload);
      if (data && data.status && data.kept) {
        setBookmarkedGroupIds((prev) => new Set(prev).add(groupId));
        setChatGroups((prev) =>
          (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: true } : row))
        );
        $crud.notify({
          type: "info",
          message: strings.bookmark_already_todo || "Diese Aufgabe wurde bereits bearbeitet und bleibt bestehen",
        });
      } else if (data && data.status && data.removed) {
        $crud.notify({
          type: "success",
          message: strings.bookmark_removed || "Vorgemerkte Aufgabe entfernt.",
        });
        dispatch({ type: REFRESH_TODO_LIST });
      }
    } catch (_) {
      setBookmarkedGroupIds((prev) => new Set(prev).add(groupId));
      setChatGroups((prev) =>
        (prev || []).map((row) => (row.id === groupId ? { ...row, isTodoBookmarked: true } : row))
      );
    }
  };

  const toggleRoomChatBookmark = (group) => {
    if (isRoomChatBookmarked(group)) removeRoomChatBookmark(group);
    else createTodoFromRoomChat(group);
  };

  const fetchClassificationBuildings = useCallback(async () => {
    try {
      const res = await callAPI(`/email/classification/buildings`, {}, "GET");
      const data = res?.data || res;
      const list = data?.buildings && Array.isArray(data.buildings) ? data.buildings : [];
      setClassificationBuildings(list.map((b) => ({
        id: b.id,
        name: b.name,
        themeColor: b.themeColor || null,
        projectNo: b.projectNo || "",
        aliases: Array.isArray(b.aliases) ? b.aliases : [],
      })));
    } catch (e) {
      // non-fatal: the assign picker just won't have autocomplete
    }
  }, []);

  const dropRoomEmailByMessageId = useCallback((messageId) => {
    if (!messageId) return;
    setRoomEmails((prev) => (prev || []).filter((item) => !roomEmailMatchesId(item, messageId)));
    closeRoomEmail();
  }, []);

  const classifyRoomEmail = useCallback(async (messageId, decision, projectName, buildingId, companyId, isInternal, onProgress) => {
    if (!messageId) return;
    const thisBuildingId = projectDetails?.id || props.project?.id;

    if (decision === "unlink") {
      let unlinked = false;
      try {
        const res = await callAPI(`/email/classification/classify`, {}, "POST", {
          messageId,
          decision: "unlink",
          buildingId: buildingId || thisBuildingId,
        });
        const data = res?.data || res;
        unlinked = !!(data && data.status === true);
      } catch (e) {
        unlinked = false;
      }
      // Room members can see a teammate's email here; classify only accepts the
      // mailbox owner, so fall back to the room-link DELETE in that case.
      if (!unlinked) {
        const fromList = (roomEmails || []).find((row) => roomEmailMatchesId(row, messageId));
        const linkId = (fromList && fromList.id) || selectedRoomEmailLinkId;
        if (linkId) {
          try {
            await callAPI(`/email/project-messages/${linkId}`, {}, "DELETE");
            unlinked = true;
          } catch (e) {
            unlinked = false;
          }
        }
      }
      if (unlinked) {
        dropRoomEmailByMessageId(messageId);
        $crud.notify({ type: "success", message: strings.email_project_removed || "Project association removed" });
      } else {
        $crud.notify({ type: "error", message: strings.something_went_wrong || "Something went wrong" });
      }
      return;
    }

    if (decision === "spam") {
      try {
        await classifySpamWithProgress({ messageId, onProgress });
        dropRoomEmailByMessageId(messageId);
      } catch (e) {
        $crud.notify({ type: "error", message: (e && e.data && e.data.message) || e?.message || strings.something_went_wrong || "Something went wrong" });
        throw e;
      }
      return;
    }

    if (decision === "project") {
      const name = (projectName || "").trim();
      if (!name && !buildingId) {
        $crud.notify({ type: "error", message: strings.email_classify_need_project || "Please enter a project name" });
        return;
      }
      const body = { messageId, decision, rememberSender: false, applyToAccount: false };
      let resolvedBuildingId = buildingId;
      if (!resolvedBuildingId && isInternal) {
        try {
          const created = await createInternalEmailRoom(name, companyId);
          resolvedBuildingId = created.id;
          dispatch({ type: UPDATE_PROJECT_ACTION_FIRE, updateProjectActionFire: true });
        } catch (createErr) {
          $crud.notify({
            type: "error",
            message: (createErr && createErr.message) || strings.something_went_wrong || "Something went wrong",
          });
          return;
        }
      }
      if (resolvedBuildingId) body.buildingId = resolvedBuildingId;
      if (name) body.buildingName = name;
      if (!resolvedBuildingId && companyId) body.companyId = companyId;
      if (!resolvedBuildingId && isInternal) body.isInternal = true;
      try {
        const { autoLinkedIds, data } = await classifyProjectWithProgress({
          messageId,
          body,
          onProgress,
        });
        const newId = (data.building && data.building.id) || resolvedBuildingId;
        const movedAway = newId && thisBuildingId && String(newId) !== String(thisBuildingId);
        if (movedAway) {
          dropRoomEmailByMessageId(messageId);
        } else {
          const tag = data.building
            ? { id: data.building.id, name: data.building.name, themeColor: data.building.themeColor || null }
            : { id: thisBuildingId, name: projectDetails?.name || name };
          setSelectedRoomEmail((prev) => (prev ? { ...prev, linkedProjects: [tag] } : prev));
        }
        const similar = autoLinkedIds.length;
        $crud.notify({
          type: "success",
          message: similar
            ? (strings.email_saved_to_project_similar || "Email saved to project. {count} similar emails were also assigned.").replace("{count}", similar)
            : (strings.email_saved_to_project || "Email saved to project"),
        });
      } catch (e) {
        $crud.notify({ type: "error", message: (e && e.data && e.data.message) || e?.message || strings.something_went_wrong || "Something went wrong" });
        throw e;
      }
    }
  }, [projectDetails?.id, projectDetails?.name, props.project?.id, dropRoomEmailByMessageId, selectedRoomEmailLinkId, roomEmails, strings, dispatch]);

  const openRoomEmailAssignModal = useCallback((em) => {
    setAssignModalEmail(assignModalSnapshot(em));
    fetchClassificationBuildings();
  }, [fetchClassificationBuildings]);

  // Client-side search over the room emails (subject / sender / snippet), so the
  // sidebar search box filters emails just like it filters chat groups.
  const filteredRoomEmails = React.useMemo(() => {
    const list = roomEmailKind === "briefing"
      ? (roomEmails || []).filter((item) => item && item.systemTag === "daily_briefing")
      : (roomEmails || []);
    const q = (search || "").trim().toLowerCase();
    if (!q) return list;
    return list.filter((item) => {
      const from = item.fromAddress || {};
      const sender = (from.name || from.email || from.address || item.senderEmail || "").toLowerCase();
      const to = Array.isArray(item.toAddresses)
        ? item.toAddresses.map((a) => `${a?.name || ""} ${a?.email || a?.address || ""}`).join(" ").toLowerCase()
        : "";
      return (
        sender.includes(q) ||
        to.includes(q) ||
        (item.subject || "").toLowerCase().includes(q) ||
        (item.snippet || "").toLowerCase().includes(q)
      );
    });
  }, [roomEmails, search, roomEmailKind]);

  const openChat = async (group, options = {}) => {
    // Guard: ensure group is defined
    if (!group || !group.id) {
      console.warn("[ProjectDetail] openChat: group is undefined or missing id", group);
      return;
    }
    const lang = (localStorage.getItem("language") || language || (isGerm ? "de" : "en")).split("-")[0].toLowerCase();
    prefetchChatMessages({
      chatId: group.id,
      userId: props.project?.ownerId || user?.id,
      translationLang: lang,
      building: group.building || id,
      viewByOwner: group.onlyView ? true : !!props.project?.viewByOwner,
    });
    const allowed = await leaveRoomComposeIfNeeded();
    if (!allowed) return;

    userOpenedChatIdRef.current = group.id;
    setOpenTeamsChat(null);

    // Fresh room write-permission so composer/Reply/Forward update when the
    // user navigates back into a chat after an Admin Panel change. Chat-level
    // flag is refreshed inside GroupConversation on mount. Do not force a
    // building refetch here — it competes with getChat on the same connection
    // pool and is the main reason room chats felt slow to open.
    if (!options.quiet) {
      getProjectDetails();
    }

    // Opening a chat group should close the project media/docs + email reader
    // without leaving the All tab when that's where the user clicked.
    setProjectDocAction(false);
    setSelectedRoomEmail(null);
    setSelectedRoomEmailLinkId(null);
    setRoomEmailReplyMode(null);
    if (roomListTab !== "all" && !options.keepRoomTab) {
      setRoomListTab(chatsHiddenPref ? "chat" : roomMessagesTab({ isViewingMode, chatsHiddenPref }));
      setProjectEmailAction(false);
      setRoomEmailKind("email");
    }

    if (!options.quiet) {
      dispatch({ type: TOGGLE_GROUP_CHAT })
    }
    // Ensure project toggle is true so sidebar stays visible when opening a room
    dispatch({ type: TOGGLE_PROJECT, payload: true })
    let tmpZ = { ...group };
    if (!group.isPilot) {
      let tmp = [...chatGroups]
      let index = tmp.findIndex(e => e.isPilot)
      if (index !== -1) {
        tmp[index].isOpened = false
        setChatGroups(tmp)
        props.updateGroupChats(tmp)
      }
      const chk = chatGroups.find((g) => g.id === group.id);

      // Always open the clicked room, don't toggle
      // IMPORTANT: Close all other chats in the same project - only one chat can be open at a time
      const updateChatGroups = await chatGroups.map((p) => {
        if (p.id === group.id) {
          // Always set to true when clicking on a room (don't toggle)
          // unreadCountAtOpen: the conversation's "N unread" band, read before the count is zeroed.
          return { ...p, isOpened: true, unreadCountAtOpen: Number(p.unseenChatCount) || Number(group.unreadCountAtOpen) || 0, unseenChatCount: 0, unseenBuildingChat: 0, unseenExternalProject: 0, unseenInternalProject: 0, unseenBuildingChatCount: 0, unseenExternalProject: 0, unseenInternalProject: 0, };
        } else {
          // Close all other chats - only one chat can be open at a time in the room section
          return { ...p, isOpened: false };
        }
      });
      setChatGroups(updateChatGroups);
      props.updateGroupChats(updateChatGroups);
      if (chk) {
        setDraftMessage($(`.textInput-${group.id}`).text(), group);
        // Always set isOpened to true when clicking on a room (don't close it)
        const unreadFromGroup = Number(group.unseenChatCount) || 0;
        const unreadFromList = (activityMessages || []).reduce((n, e) => {
          if (e.group && String(e.group.id) === String(group.id)) {
            return n + (Number(e.unseenChatCount) || 0);
          }
          return n;
        }, 0);
        const unreadForBadges = Math.max(unreadFromList, unreadFromGroup);
        let tmp = [...activityMessages];
        tmp = tmp.map((e) => {
          const match = e.buildingList == props.id && e.group && e.group.id == group.id;
          return {
            ...e,
            isOpened: match ? true : e.isOpened,
            unseenChatCount: match ? 0 : e.unseenChatCount,
          };
        });
        let tmp1 = [...activityMessagesReminders];
        tmp1 = tmp1.map((e) => {
          const match = e.buildingList == props.id && e.group && e.group.id == group.id;
          return {
            ...e,
            isOpened: match ? true : e.isOpened,
            unseenChatCount: match ? 0 : e.unseenChatCount,
          };
        });
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: tmp });
        dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: tmp1 });
        if (unreadForBadges > 0) {
          dispatch({
            type: ALL_BADGE_COUNT,
            unSeenAllCount: applyOptimisticChatRead(store.getState().unSeenAllCount, {
              isOneToOne: false,
              isInternal: !!props.project?.isInternal,
              unreadCount: unreadForBadges,
            }),
          });
          const roomId = props.id || group.building || group.buildingList;
          const nextLists = decrementRoomUnreadInLists(
            store.getState().projects,
            store.getState().internalProjectsAll,
            roomId,
            unreadForBadges
          );
          if (nextLists.changed) {
            dispatch({ type: PROJECTS, projects: nextLists.projects });
            dispatch({ type: INTERNAL_PROJECTS, projects: nextLists.internalProjectsAll });
          }
        }
      } else {
        const unreadFromList = (activityMessages || []).reduce((n, e) => {
          if (e.group && String(e.group.id) === String(group.id)) {
            return n + (Number(e.unseenChatCount) || 0);
          }
          return n;
        }, 0);
        let tmpx = [...activityMessages];
        tmpx = tmpx.map((e) => {
          const match = e.buildingList == props.id && e.group && e.group.id == group.id;
          return {
            ...e,
            isOpened: match ? true : e.isOpened,
            unseenChatCount: match ? 0 : e.unseenChatCount,
          };
        });
        let tmp1 = [...activityMessagesReminders];
        tmp1 = tmp1.map((e) => {
          return {
            ...e,
            isOpened:
              e.buildingList == props.id && e.group && e.group.id == group.id
                ? false
                : e.isOpened,
          };
        });
        dispatch({ type: SET_ACTIVITY_MESSAGES, messages: tmpx });
        dispatch({ type: SET_ACTIVITY_MESSAGES_REMINDERS, messages: tmp1 });
        if (unreadFromList > 0) {
          dispatch({
            type: ALL_BADGE_COUNT,
            unSeenAllCount: applyOptimisticChatRead(store.getState().unSeenAllCount, {
              isOneToOne: false,
              isInternal: !!props.project?.isInternal,
              unreadCount: unreadFromList,
            }),
          });
        }
        setDraftMessage($(`.textInput-${group.id}`).text(), group);
        props.updateGroupChats(updateChatGroups);
        let isInternal = -1;
        let isExternal = projects.findIndex((e) => e.id == group.building);
        let TXX = [...internalProjectsAll];
        if (!group.isPilot) {
          for (let obj of TXX) {
            if (obj.userProjectList && obj.userProjectList.length > 0) {
              let ind = obj.userProjectList.findIndex(
                (e) => e.id == group.building
              );
              if (ind !== -1) {
                isInternal = 1;
                obj.totalUnreadChat =
                  obj.totalUnreadChat - group.unseenChatCount < 0
                    ? 0
                    : obj.totalUnreadChat - group.unseenChatCount;
                obj.userProjectList[ind].unseenBuildingChat =
                  obj.userProjectList[ind].unseenBuildingChat -
                    group.unseenChatCount <
                    0
                    ? 0
                    : obj.userProjectList[ind].unseenBuildingChat -
                    group.unseenChatCount;
              }
            }
          }
          if (isExternal !== -1) {
            let TXXEXTERNAL = [...projects];
            TXXEXTERNAL[isExternal].unseenBuildingChat =
              TXXEXTERNAL[isExternal].unseenBuildingChat - group.unseenChatCount < 0
                ? 0
                : TXXEXTERNAL[isExternal].unseenBuildingChat -
                group.unseenChatCount;
            dispatch({ type: PROJECTS, projects: TXXEXTERNAL });
          }
        }
        dispatch({ type: INTERNAL_PROJECTS, projects: TXX });
        // Do not decrement the global SideNav badge here. Opening a room
        // chat used to subtract unseenChatCount immediately, so the
        // Messages counter disappeared before subscribe marked the
        // messages as read. GroupConversation._subsOnly + /badge/count
        // update the badge once they are actually read.
        let tmp = [...AllGroupsOfProjects];
        let allGrps = tmp.findIndex((e) => e.projectId == group.building);
        if (allGrps !== -1) {
          let currentGroup = [...tmp[allGrps].groups];
          let gIndex = currentGroup.findIndex((e) => e.id == group.id);
          if (gIndex !== -1) {
            tmp[allGrps].groups[gIndex].unseenChatCount = 0;
            dispatch({
              type: SET_ALLGROUPS_PROJECTS,
              payload: {
                projectId: group.building,
                newGroups: tmp[allGrps].groups,
              },
            });
          }
        }
      }
    }
    else {
      let tmp = [...chatGroups]
      let index = tmp.findIndex(e => e.isPilot)
      // IMPORTANT: Don't close all chats - only toggle the pilot chat
      // Preserve isOpened state for all non-pilot chats
      if (index !== -1) {
        tmp[index].isOpened = !tmp[index].isOpened
        setChatGroups(tmp)
        props.updateGroupChats(tmp)
      }
    }
  };

  const handleCloseChat = async (id, isLeave = false) => {
    if (userOpenedChatIdRef.current && String(userOpenedChatIdRef.current) === String(id)) {
      userOpenedChatIdRef.current = null;
    }
    const updateChatGroups = await chatGroups.map((p) => {
      if (p.id === id) {
        if (isLeave) {
          return { ...p, isOpened: false, isLeave: true, disabled: true };
        } else {
          return { ...p, isOpened: false };
        }
      } else {
        return { ...p };
      }
    });
    let sortData = updateChatGroups?.sort(
      (a, b) => (a.isLeave === true) - (b.isLeave === true)
    );
    if (isLeave) {
      setChatGroups(updateChatGroups);
    } else {
      setChatGroups(sortData);
    }
  };

  const openRoomChatFromTodo = ({ groupId, messageId, page_no }) => {
    if (!groupId) return;
    rememberReturnTab();
    if (messageId) {
      const target = {
        chatGroupId: groupId,
        messageId,
        page_no: page_no || 1,
        requestId: Date.now(),
      };
      setDeeplinkScrollTarget(target);
      dispatch({
        type: SET_DEEPLINK_DATA,
        payload: {
          chatGroupId: groupId,
          messageId,
          page_no: page_no || 1,
          fromTodo: true,
          roomId: projectDetails?.id || props.project?.id,
          isInternal: Boolean(props.project?.isInternal),
        },
      });
    }
    const alreadyOpen =
      String(userOpenedChatIdRef.current) === String(groupId) ||
      (chatGroups || []).some((g) => g.isOpened && String(g.id) === String(groupId));
    if (alreadyOpen) {
      userOpenedChatIdRef.current = groupId;
      return;
    }
    const group = (chatGroups || []).find((g) => String(g.id) === String(groupId));
    if (group) {
      openChat(group, { quiet: true, keepRoomTab: !companionLayout });
    } else {
      userOpenedChatIdRef.current = groupId;
      openChat({
        id: groupId,
        building: projectDetails?.id || props.project?.id,
        isOpened: true,
      }, { quiet: true, keepRoomTab: !companionLayout });
    }
  };

  const openRoomEmailFromTodo = ({ emailMessageId, emailAccountId }) => {
    if (!emailMessageId) return;
    rememberReturnTab();
    const match = (roomEmails || []).find((it) =>
      String(it.messageId) === String(emailMessageId) ||
      String(it.id) === String(emailMessageId) ||
      String(it._id) === String(emailMessageId)
    );
    openRoomEmail(match || {
      id: emailMessageId,
      messageId: emailMessageId,
      emailAccountId,
      emailAccount: emailAccountId,
      accountId: emailAccountId,
    });
  };

  const handleForward = async () => {
    const countGroups = selectedGroups.length;
    if (countGroups > 0) {
      setViewLoader(true);
      const { data } = await callAPI("/message/forward", {}, "POST", {
        group: selectedGroups,
        id: props.forwardGroupMessages.msgIds,
      });
      if (data.status) {
        $crud.notify({
          type: "success",
          message: strings.message_forwarded,
        });
      }
      props.updateForwardGroupMessage({});
      props.updateForwardGroupMessage([]);
      await selectedGroupData?.map((itm) => openChat(itm));
      await setActiveForward(false);
      await setSelectedGroups([]);
      await setSelectedGroupData([]);
      setViewLoader(false);
    } else {
      $crud.notify({
        type: "error",
        message: "Please select group to forward message",
      });
    }
  };
  const handleCancel = () => {
    props.updateForwardGroupMessage([]);
    setActiveForward(false);
  };

  const selectIds = (id, group) => {
    const chk = selectedGroups.find((g) => g === id);
    if (!chk) {
      const ids = [...selectedGroups, id];
      setSelectedGroups(ids);
      const data = [...selectedGroupData, group];
      setSelectedGroupData(data);
    } else {
      const ids = selectedGroups.filter((g) => g !== id);
      const datas = selectedGroupData.filter((g) => g?.id !== group?.id);
      setSelectedGroups(ids);
      setSelectedGroupData(datas);
    }
  };
  useEffect(() => {
    if (
      props.forwardGroupMessages &&
      props.forwardGroupMessages.building === id
    ) {
      setActiveForward(true);
      setDpId(props.forwardGroupMessages.gpId);
    }
  }, [props.forwardGroupMessages]);

  //Search Project
  const searchProject = async (e) => {
    const value = e.target.value.trim();
    setSearch(value);
    // On All / E-Mail / Briefings the search box filters the derived lists;
    // leave the chat groups array untouched.
    if (roomListTab !== "chat") {
      return;
    }
    const searchResult = await chatGroups.filter((project) => {
      if (value === "") {
        return project;
      } else if (project.name?.toLowerCase().includes(value?.toLowerCase())) {
        return project;
      }
    });
    if (value === "") {
      setChatGroups(disableGroup);
    } else {
      setChatGroups(searchResult);
    }
  };
  const handleLeaveProject = async (projectId) => {
    let filterData = chatGroups?.map((it) =>
      it.id === projectId ? { ...it, isLeave: true, disabled: true } : { ...it }
    );
    let sortData = filterData.sort(
      (a, b) => (a.isLeave === true) - (b.isLeave === true)
    );
    setChatGroups(sortData);
    setDisableGroup(sortData);
    handleCloseChat(projectId, true);
    const oldData = await props.groupChats.filter((p) => p.id !== projectId);
    props.updateGroupChats(oldData);
  };


  const _deleteMemberFromProject = async (id, index, mainIndex) => {
    const { data } = await callAPI(
      `/building/${projectDetails.id}/remove/${id}`,
      null,
      "DELETE"
    );
    if (data.status) {
      let tmp = [...users];
      tmp[mainIndex].names.splice(index, 1);
      setUsers([...tmp]);
      $crud.notify({
        type: "success",
        message: data.message,
      });
    } else {
      $crud.notify({
        type: "error",
        message: data.message,
      });
    }
  };

  const navigateUserProfile = (userId) => {
    if (!userId) return;
    requestDirectMessage({ id: userId });
  };

  // Handle mute/unmute confirmation
  const handleMuteUnmuteClick = (group, mute) => {
    setSelectedGroupForMute(group);
    setIsMuteAction(mute);
    setShowMuteConfirm(true);
  };

  const confirmMuteUnmute = async () => {
    if (!selectedGroupForMute) return;

    dispatch({ type: SET_LOADER, loader: true });
    try {
      const { data } = await callAPI(
        "/group/muteUnmuteChat",
        {
          mute: isMuteAction,
          group: selectedGroupForMute.id,
        },
        "PUT"
      );

      if (data.status) {
        $crud.notify({
          type: "success",
          message: isMuteAction
            ? strings.chat_muted_successfully
            : strings.chat_unmuted_successfully,
        });

        // Update local chat groups state - update isMute for current user in users array
        const updatedChatGroups = chatGroups.map((g) => {
          if (g.id === selectedGroupForMute.id) {
            const updatedUsers = g.users.map((u) =>
              u.id === user.id ? { ...u, isMute: isMuteAction } : u
            );
            return { ...g, users: updatedUsers };
          }
          return g;
        });
        setChatGroups(updatedChatGroups);
        props.updateGroupChats(updatedChatGroups);

        // Update AllGroupsOfProjects in Redux
        let tmp = [...AllGroupsOfProjects];
        let allGrps = tmp.findIndex((e) => e.projectId == selectedGroupForMute.building);
        if (allGrps !== -1) {
          let currentGroup = [...tmp[allGrps].groups];
          let gIndex = currentGroup.findIndex((e) => e.id == selectedGroupForMute.id);
          if (gIndex !== -1) {
            const updatedUsers = tmp[allGrps].groups[gIndex].users.map((u) =>
              u.id === user.id ? { ...u, isMute: isMuteAction } : u
            );
            tmp[allGrps].groups[gIndex].users = updatedUsers;
            dispatch({
              type: SET_ALLGROUPS_PROJECTS,
              payload: {
                projectId: selectedGroupForMute.building,
                newGroups: tmp[allGrps].groups,
              },
            });
          }
        }
      } else {
        $crud.notify({
          type: "error",
          message: data.message || (isGerm ? "Etwas ist schief gelaufen" : "Something went wrong"),
        });
      }
    } catch (error) {
      $crud.notify({
        type: "error",
        message: isGerm ? "Etwas ist schief gelaufen" : "Something went wrong",
      });
    } finally {
      dispatch({ type: SET_LOADER, loader: false });
      setShowMuteConfirm(false);
      setSelectedGroupForMute(null);
    }
  };

  const cancelMuteUnmute = () => {
    setShowMuteConfirm(false);
    setSelectedGroupForMute(null);
  };


  const filterAdmins = async (searchValue) => {
    setSearchUser(searchValue);
    searchValue = searchValue.trim();
    if (searchValue) {
      let userListFilter = await usersBackUp.map((item) => {
        let filterName = item.names.filter((itm) => {
          let fullName =
            `${itm.firstName.trim()} ${itm.lastName.trim()}`?.toLowerCase();
          if (
            itm.firstName?.toLowerCase().startsWith(searchValue?.toLowerCase()) ||
            itm.lastName?.toLowerCase().startsWith(searchValue?.toLowerCase()) ||
            fullName?.toLowerCase().startsWith(searchValue?.toLowerCase())
          ) {
            return true;
          }
        });
        return { ...item, names: filterName };
      });
      userListFilter = userListFilter.filter(
        (position) => position.names.length > 0
      );
      setUsers(userListFilter);
    } else {
      setUsers(usersBackUp);
    }
  };

  const closeOpenedChats = () => {
    const closedGroups = chatGroups.map((g) => (g.isOpened ? { ...g, isOpened: false } : g));
    setChatGroups(closedGroups);
    props.updateGroupChats(closedGroups);
  };

  const rememberReturnTab = (tab = roomListTab) => {
    if (!companionLayout && (tab === "todos" || tab === "briefing")) {
      setReturnToRoomTab(tab);
    }
  };

  const restoreReturnTab = () => {
    if (!returnToRoomTab) return;
    setRoomListTab(returnToRoomTab);
    if (returnToRoomTab !== "email") {
      setProjectEmailAction(false);
      setRoomEmailKind("email");
    }
    setReturnToRoomTab(null);
  };

  const dismissOpenRoomChat = () => {
    userOpenedChatIdRef.current = null;
    closeOpenedChats();
    restoreReturnTab();
  };

  // Chats hidden while a chat tab is active (pref changed, or a room that was
  // mounted before) -> move the list to E-Mail without a compose prompt.
  useEffect(() => {
    if (!chatsHiddenPref || isViewingMode) return;
    if (roomListTab !== "all" && roomListTab !== "chat") return;
    userOpenedChatIdRef.current = null;
    closeOpenedChats();
    setShowMember(false);
    setRoomListTab("email");
    setProjectEmailAction(true);
    setRoomEmailKind("email");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatsHiddenPref, isViewingMode, roomListTab]);

  // Opened for one of its tasks (cockpit, search, push): show Aufgaben. The
  // task pane opens the task itself and clears the request.
  const pendingProjectTask = useSelector((state) => state.pendingProjectTask);
  const thisRoomId = projectDetails?.id || props.project?.id;
  useEffect(() => {
    if (!pendingProjectTaskIsFresh(pendingProjectTask) || isViewingMode || thisRoomId == null) return;
    if (String(pendingProjectTask.roomId) !== String(thisRoomId)) return;
    if (!pendingProjectTask.todoId) dispatch({ type: SET_PENDING_PROJECT_TASK, payload: null });
    if (companionLayout ? roomRightTab !== "todos" : roomListTab !== "todos") selectRoomTab("todos");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingProjectTask, thisRoomId, isViewingMode, companionLayout]);

  const selectRoomTab = async (tab) => {
    if (isViewingMode && tab !== "chat" && tab !== "media") {
      return;
    }
    if (chatsHiddenPref && (tab === "all" || tab === "chat")) {
      tab = "email";
    }
    const allowed = await leaveRoomComposeIfNeeded();
    if (!allowed) return;
    // Aufgaben beside the list (wide layout) leave the left tab as it is.
    if (tab !== "todos" || !companionLayout) {
      roomOverviewPickedRef.current = true;
      setRoomOverviewOpen(tab === "overview");
    }

    if (tab === "overview") {
      setShowMember(false);
      setProjectDocAction(false);
      setSelectedRoomEmail(null);
      setSelectedRoomEmailLinkId(null);
      setRoomEmailReplyMode(null);
      if (roomListTab === "todos") setRoomListTab(roomMessagesTab({ isViewingMode, chatsHiddenPref }));
      return;
    }

    if (tab === "media") {
      setShowMember(false);
      setProjectDocAction(true);
      setSelectedRoomEmail(null);
      setSelectedRoomEmailLinkId(null);
      setRoomEmailReplyMode(null);
      return;
    }

    if (tab === "todos" || tab === "briefing") {
      setShowMember(false);
      setProjectDocAction(false);
      setRoomRightTab(tab);
      if (companionLayout) {
        if (tab === "todos" && selectedRoomEmail?.systemTag === "daily_briefing") {
          setSelectedRoomEmail(null);
          setSelectedRoomEmailLinkId(null);
          setRoomEmailReplyMode(null);
        }
        setProjectEmailAction(false);
        setRoomEmailKind("email");
        return;
      }
      closeOpenedChats();
      setSelectedRoomEmail(null);
      setSelectedRoomEmailLinkId(null);
      setRoomEmailReplyMode(null);
      setRoomListTab(tab);
      if (tab === "briefing") {
        setProjectEmailAction(true);
        setRoomEmailKind("briefing");
        setRoomEmailDirection("incoming");
      } else {
        setProjectEmailAction(false);
        setRoomEmailKind("email");
      }
      return;
    }

    setShowMember(false);
    setProjectDocAction(false);
    setSelectedRoomEmail(null);
    setSelectedRoomEmailLinkId(null);
    setRoomEmailReplyMode(null);
    setRoomListTab(tab);
    if (tab === "teams") {
      setProjectEmailAction(false);
      setRoomEmailKind("email");
      closeOpenedChats();
      listTeamsProjectChats(roomTeamsRoomId).then(setRoomTeamsChats);
      return;
    }
    if (tab === "email") {
      setProjectEmailAction(true);
      setRoomEmailKind("email");
      closeOpenedChats();
    } else {
      setProjectEmailAction(false);
      setRoomEmailKind("email");
    }
  };

  const openRoomComposeEmail = async () => {
    const allowed = await leaveRoomComposeIfNeeded();
    if (!allowed) return;
    setProjectDocAction(false);
    setSelectedRoomEmail(null);
    setSelectedRoomEmailLinkId(null);
    setRoomEmailReplyMode("new");
    fetchClassificationBuildings();
  };

  const openRoomCreateChat = () => {
    setShowRoomCreateSelector(false);
    setAddChatUserAction({
      status: true,
      id: id,
      isInternal: props.project.isInternal,
      cID: props.project.cID,
    });
  };

  const handleRoomAddClick = (e) => {
    if (e) e.preventDefault();
    const choices = roomCreateChoices({
      roomListTab,
      chatsHiddenPref,
      emailFeatureEnabled,
      teamsAvailable: canStartRoomTeamsChat({ teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails }),
    });
    if (choices.length > 1) {
      setShowRoomCreateSelector((open) => !open);
      return;
    }
    if (choices[0] === "email") openRoomComposeEmail();
    else if (choices[0] === "chat") openRoomCreateChat();
  };

  const _renderRoomStreamEmail = (item) => {
    if (!item) return null;
    const selected = String(selectedRoomEmailLinkId) === String(item.id)
      || String(selectedRoomEmail?.id) === String(item.messageId || item.id)
      || String(selectedRoomEmail?.messageId) === String(item.messageId || item.id);
    return (
      <EmailFeedRow
        key={`email-${item.id || item.messageId}`}
        item={item}
        selected={selected}
        strings={strings}
        onOpen={openRoomEmail}
        onDelete={(row) => removeRoomEmail(row?.id, row)}
        deleting={removingRoomEmail}
        onBookmark={toggleRoomEmailBookmark}
        isBookmarked={isRoomEmailBookmarked(item)}
      />
    );
  };

  const _renderKjuupPilot = (group) => {
    let opened = group.isOpened && !projectDocAction && !selectedRoomEmail ? 1 : -1;
    return (
      <div
        key={group.id}
        className={
          "company_centact pointer"
        }
        style={
          opened !== -1
            ? {
              backgroundColor: props.project
                .isInternal
                ? KJUUP_COLORS.internalLight
                : "#ffffff",
            }
            : { backgroundColor: "transparent" }
        }
        onClick={() => openChat(group)}
      >
        <div
          className="website"
          onClick={(e) => {

          }}
        >
          <div className="website_img">
            <img className="img_active" style={{ width: 35 }}
              src={PilotLogo} />
          </div>
          <div className="details-company forword-checkbox_main">
            <h5>
              Kjuup Pilot
            </h5>
            <div className="lastMessage m-0">
              <p>
                {strings.pilot_text}
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const _renderRoomLastMessagePreview = (group) => {
    if (!group || group.lastMessageDeleted) return null;
    const type = group.lastMessageType || group.messageType;
    if (type === "poll") {
      return (
        <p className="m-0 text-truncate message-type-preview" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <i className="poll-preview-icon">how_to_reg</i> {strings.create_poll || "Poll"}
        </p>
      );
    }
    if (type === "doc") {
      return (
        <p className="m-0 text-truncate message-type-preview">
          <RoomMessageTypeIcon icon="description" /> {strings.document}
        </p>
      );
    }
    if (type === "video") {
      return (
        <p className="m-0 text-truncate message-type-preview">
          <RoomMessageTypeIcon icon="videocam" /> {strings.video}
        </p>
      );
    }
    if (type === "image") {
      const preview = group.lastMessage || group.message || "";
      const isFallback =
        preview === (strings?.s_image || "Image") ||
        preview === (strings?.m_image || "Images");
      let caption = "";
      if (preview && !isFallback && String(preview).trim()) {
        caption = onlyUsername(
          String(preview)
            .replace(/<br\s*[/]?>/gi, " ")
            .replace(/<[^>]+>/g, " ")
            .replace(/\s+/g, " ")
            .trim(),
          strings
        );
      }
      return (
        <div className="m-0 text-truncate message-type-preview image">
          <RoomMessageTypeIcon icon="image" />
          <span className="image-count-text">
            {` ${strings.s_image}`}
            {caption ? <span className="image-message-text">{` | ${formatName(caption, 25)}`}</span> : null}
          </span>
        </div>
      );
    }
    if (type === "audio") {
      return (
        <p className="m-0 text-truncate message-type-preview">
          <RoomMessageTypeIcon icon="mic" /> {strings.audio}
        </p>
      );
    }
    if (type === "map") {
      return (
        <p className="m-0 text-truncate message-type-preview">
          <RoomMessageTypeIcon icon="location_on" /> {strings.location}
        </p>
      );
    }
    if (type === "contact") {
      return (
        <p className="m-0 text-truncate message-type-preview">
          <RoomMessageTypeIcon icon="person" /> {group.lastMessage || ""}
        </p>
      );
    }
    if (!group.lastMessage) return null;
    return (
      <div
        className="last-message-preview"
        style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", margin: 0 }}
      >
        <MarkdownPreview
          text={onlyUsername(group.lastMessage.replace(/<br\s*[/]?>/gi, " "), strings)}
          strings={strings}
          className="message-preview-text"
        />
      </div>
    );
  };

  // A Microsoft Teams chat filed under this room. It opens in the room's message pane like a room
  // chat, in the room-less chat pane's Teams mode (it has no room membership).
  const openRoomTeamsChat = async (chat, name) => {
    if (!chat || !chat.groupId) return;
    const allowed = await leaveRoomComposeIfNeeded();
    if (!allowed) return;
    userOpenedChatIdRef.current = null;
    closeOpenedChats();
    setShowMember(false);
    setProjectDocAction(false);
    setSelectedRoomEmail(null);
    setSelectedRoomEmailLinkId(null);
    setRoomEmailReplyMode(null);
    const groupId = String(chat.groupId);
    setOpenTeamsChat(teamsChatEntry({ ...chat, isTeams: true, source: "teams" }, {
      id: groupId,
      key: groupId,
      name,
      isOpened: true,
      onlyView: false,
      unseenChatCount: 0,
      unreadCountAtOpen: 0,
    }));
  };

  // The open Teams chat in the message pane. A function, not inline JSX: every branch in this
  // component's body counts towards eslint-plugin-react-hooks' path limit (false positives).
  const renderRoomTeamsChatPane = () => {
    if (!teamsChatInPane || emailInReportPane) return null;
    return (
      <div
        className="room-message-pane-fill"
        style={roomPaneFillStyle}
      >
        <Coversation
          key={`teams-${teamsChatInPane.id}`}
          chat={teamsChatInPane}
          chat_key={teamsChatInPane.key}
          openChatArr={[teamsChatInPane]}
          isFromLatestMsg={true}
          handleClose={closeRoomTeamsChat}
          onBackToParent={closeRoomTeamsChat}
        />
      </div>
    );
  };

  // A Teams chat started from the room's new-chat picker (Teams contacts only), filed under this
  // room: the room's Teams rows reload and the chat opens in the room's message pane.
  const openCreatedRoomTeamsChat = (created) => {
    listTeamsProjectChats(roomTeamsRoomId).then(setRoomTeamsChats);
    openRoomTeamsChat({ groupId: created.groupId, teamsChatType: created.chatType, name: created.name }, created.name);
  };

  // Back from the Teams chat: the room list again, with the row's preview refreshed.
  const closeRoomTeamsChat = () => {
    setOpenTeamsChat(null);
    listTeamsProjectChats(roomTeamsRoomId).then(setRoomTeamsChats);
  };

  const _renderRoomTeamsChat = (chat) => {
    if (!chat || !chat.groupId) return null;
    const last = chat.lastMessage || null;
    const name = stripMarkdown(chat.name || "Microsoft Teams");
    const sender = last
      ? (last.senderIsMe ? (strings.teams_sender_you || (isGerm ? "Du" : "You")) : String(last.senderName || "").split(" ")[0])
      : "";
    const text = last ? String(last.text || last.fileName || "") : "";
    const preview = last
      ? {
          lastMessageType: last.messageType,
          lastMessage: last.messageType === "simple" || !last.messageType ? [sender, text].filter(Boolean).join(": ") : text,
        }
      : null;
    return (
      <div
        key={`teams-${chat.groupId}`}
        className={`company_centact chat-item-container${openTeamsChat && String(openTeamsChat.id) === String(chat.groupId) ? " active-project" : ""}`}
      >
        <a
          className="website pointer chat-item-link"
          onClick={(e) => {
            e.preventDefault();
            if (!activeForward) openRoomTeamsChat(chat, name);
          }}
        >
          {/* The Messages list's avatar: a 1:1 like a direct chat, a group like a group, with the Teams logo. */}
          <div className="website_img" style={{ position: "relative" }}>
            <ChatListAvatar
              kind={chat.teamsChatType === "oneOnOne" ? "direct" : "group"}
              name={name}
              teams
            />
          </div>
          <div className="details-company forword-checkbox_main chat-details-container">
            <div className="m-0 chat-header-row">
              <div className="chat-title-row">
                <h5 style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{name}</h5>
                <span className="room-chat-header-right">
                  <span className="chat-time-inline">
                    {chat.messageDate ? moment(chat.messageDate).format("HH:mm") : ""}
                  </span>
                </span>
              </div>
            </div>
            <div className="m-0 chat-message-row" style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
              <span className="lmp-kind-tag lmp-kind-tag--teams">
                {String(strings.pro_messages_tag_teams || "Teams").toUpperCase()}
              </span>
              <div style={{ minWidth: 0, flex: 1 }}>{preview ? _renderRoomLastMessagePreview(preview) : null}</div>
            </div>
          </div>
        </a>
      </div>
    );
  };

  const _renderRoomChatGroup = (group) => {
    if (!group) return null;
    if (group.isPilot) return _renderKjuupPilot(group);
    const chatUser = (group.users || []).filter((u) => u.id == user.id);
    if (!(chatUser?.length > 0 || group.onlyView)) return null;

    const opened = group.isOpened && !projectDocAction && !selectedRoomEmail ? 1 : -1;
    const isDeactivated = !!(chatUser[0]?.isLeave || projectDetails.isDone);
    const isMuted = !!chatUser[0]?.isMute;
    const canMute = chatUser?.length > 0 && !isDeactivated;
    const themeColor = isDeactivated
      ? "grey"
      : (projectDetails?.themeColor || (props.project.isInternal ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color));
    const displayName = group.defaultChatGroup
      ? strings.all_members || (isGerm ? "Alle" : "All")
      : truncateGroupName(
          stripMarkdown(translatedGroupNames[group.id] || group.translatedName || group.name).replace(
            /All members of the (room|project)/,
            strings.all_member_of_project
          )
        );
    const initialsSource = String(group.name || "").includes(strings.all_member_of_project)
      ? projectDetails?.name
      : stripMarkdown(group.name);
    const draft = storedDraftMessage.find((m) => m.group === group.id);
    const showUnseen = !isMuted && !group.isOpened && group.unseenChatCount > 0;
    const leftClass = [
      "company_centact",
      "chat-item-container",
      chatUser?.length > 0 && chatUser[0]?.isLeave ? "disable-group" : "",
      opened !== -1 ? "active-project" : "",
    ].filter(Boolean).join(" ");

    return (
      <div key={group.id} className={leftClass}>
        <a
          className="website pointer chat-item-link"
          onClick={(e) => {
            e.preventDefault();
            if (!activeForward) openChat(group);
          }}
          onMouseEnter={() => {
            if (!group?.id) return;
            const lang = (localStorage.getItem("language") || language || (isGerm ? "de" : "en")).split("-")[0].toLowerCase();
            prefetchChatMessages({
              chatId: group.id,
              userId: props.project?.ownerId || user?.id,
              translationLang: lang,
              building: group.building || id,
              viewByOwner: group.onlyView ? true : !!props.project?.viewByOwner,
            });
          }}
        >
          <div className="website_img" style={{ position: "relative" }}>
            <GroupAvatarImage
              src={group.image ? BASE_URL + group.image : null}
              alt={group.name}
              initials={getProjectName(initialsSource)}
              themeColor={themeColor}
              style={isDeactivated ? { opacity: 0.5 } : undefined}
            />
            {(props.project.viewByOwner || group.onlyView) && (
              <MaterialIcon
                icon="visibility"
                className="admin-view-eye"
                size={16}
                fill={1}
                color={props.project.isInternal ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color}
                style={{
                  width: 16,
                  height: 16,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              />
            )}
            {canMute && (
              <span
                className="material-symbols-outlined mute-icon-badge"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  handleMuteUnmuteClick(group, !isMuted);
                }}
                title={isMuted ? (strings.unmute || (isGerm ? "Stummschaltung aufheben" : "Unmute")) : (strings.mute || (isGerm ? "Stummschalten" : "Mute"))}
                onMouseEnter={(e) => { e.currentTarget.style.transform = "scale(1.3)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
                style={MUTE_BADGE_STYLE}
              >
                {isMuted ? "notifications_off" : "notifications_active"}
              </span>
            )}
          </div>
          <div
            className="details-company forword-checkbox_main chat-details-container"
            style={isDeactivated ? { opacity: 0.5 } : undefined}
          >
            <div className="m-0 chat-header-row">
              <div className="chat-title-row">
                <h5
                  className={isDeactivated ? "text-grey" : ""}
                  style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {displayName}
                </h5>
                {showUnseen && (
                  <Badge className="project-notification pointer message-badge unseen-badge">
                    <span className="unseen-badge-text">{group.unseenChatCount}</span>
                  </Badge>
                )}
                <span className="room-chat-header-right">
                  <span className="chat-time-inline">
                    {group.messageDate ? moment(group.messageDate).format("HH:mm") : ""}
                  </span>
                  {canBookmarkRoomChat(group) && !isDeactivated && (
                    <button
                      type="button"
                      className={`room-chat-bookmark-btn${isRoomChatBookmarked(group) ? " filled" : ""}`}
                      title={isRoomChatBookmarked(group) ? strings.unmark_task || "Remove from tasks" : strings.mark_as_task || "Mark as task"}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        toggleRoomChatBookmark(group);
                      }}
                    >
                      <MaterialIcon
                        icon={isRoomChatBookmarked(group) ? "task_alt" : "add_task"}
                        size={22}
                        color={isRoomChatBookmarked(group) ? "var(--kjuup-accent)" : "#737373"}
                        fill={isRoomChatBookmarked(group) ? 1 : 0}
                        weight={300}
                        grade={0}
                        className="bookmark-action-icon"
                      />
                    </button>
                  )}
                </span>
              </div>
            </div>
            <div className="m-0 chat-message-row">
              {draft && !group.isBlock ? (
                <p className="m-0 lm-draft-preview">
                  <span className="lm-draft-label">{strings.draft_prefix || "Draft:"}</span>{" "}
                  {getDraftPreviewText(draft.message)}
                </p>
              ) : (
                _renderRoomLastMessagePreview(group)
              )}
            </div>
          </div>
        </a>
        {activeForward && group.id != gpId && !isDeactivated && (
          <div className="chat-right-column">
            <label className={`container_checkbox ${props.project.isInternal ? "checkbox-internal" : ""}`} style={{ margin: 0 }}>
              <input
                type="checkbox"
                onClick={(e) => {
                  e.stopPropagation();
                  selectIds(group.id, group);
                }}
              />
              <span className="checkmark" style={{ top: 0 }}></span>
            </label>
          </div>
        )}
      </div>
    );
  };

  const activeSideBar = useSelector(e => e.activeSideBar)
  const isLatestMessagesSidebar = activeSideBar === 'LatestMessages';
  const roomPaneFillStyle = {
    flex: 1,
    minHeight: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    background: "#fff",
    overflow: "hidden",
    borderRadius: 0,
  };

  const deeplinkData = useSelector(state => state.deeplinkData)

  // Capture deeplink messageId/page_no immediately when deeplinkData arrives,
  // before any other effect or getChats() can clear it.
  useEffect(() => {
    if (deeplinkData?.chatGroupId && deeplinkData?.messageId) {
      console.log('[ProjectDetail] Capturing deeplink scroll target', {
        chatGroupId: deeplinkData.chatGroupId,
        messageId: deeplinkData.messageId,
        page_no: deeplinkData.page_no,
      });
      setDeeplinkScrollTarget({
        chatGroupId: deeplinkData.chatGroupId,
        messageId: deeplinkData.messageId,
        page_no: deeplinkData.page_no,
      });
    }
  }, [deeplinkData?.chatGroupId, deeplinkData?.messageId]);

  const [openDeepGroup, setOpenDeepGroup] = useState(false)

  // Mute/Unmute state
  const [showMuteConfirm, setShowMuteConfirm] = useState(false);
  const [selectedGroupForMute, setSelectedGroupForMute] = useState(null);
  const [isMuteAction, setIsMuteAction] = useState(true);

  // Collapsible section state — keys must stay language-independent
  const [expandedSections, setExpandedSections] = useState({
    [CHAT_SECTION_KEYS.DEACTIVATED]: false,
  });

  useEffect(() => {
    setShowRoomCreateSelector(false);
  }, [roomListTab]);

  useEffect(() => {
    if (!showRoomCreateSelector) return undefined;
    const handleClickOutside = (event) => {
      if (roomCreateSelectorRef.current && !roomCreateSelectorRef.current.contains(event.target)) {
        setShowRoomCreateSelector(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showRoomCreateSelector]);

  useEffect(() => {
    if (openDeepGroup) {
      openChat(openDeepGroup)
      // Only clear deeplinkData if there's no pending message scroll.
      // GroupConversation will clear it after scrolling to the target message.
      if (!deeplinkData?.messageId) {
        dispatch({ type: SET_DEEPLINK_DATA, payload: null });
      }
      dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
    }
    setOpenDeepGroup(false)
  }, [openDeepGroup])

  useEffect(() => {
    if (newGroupData) {
      const building = newGroupData.building;
      const groupId = newGroupData.id;
      
      logProjectDetail("newGroupData:run", {
        projectId: props.project?.id,
        building,
        groupId
      });
      
      // Check if this group is for the current room
      if (building && groupId && props.project?.id && building.toString() === props.project.id.toString()) {
        // IMPORTANT: Clear deeplinkData first to prevent the other effect from opening a different group
        dispatch({ type: SET_DEEPLINK_DATA, payload: null });
        
        // Mark that we're adding a new group - this prevents groupIdLat effect from reopening old group
        newGroupJustAddedRef.current = true;
        // Store the group ID so getChats() can ensure it stays selected after fetching all groups
        newGroupIdToOpenRef.current = groupId;
        userOpenedChatIdRef.current = groupId;
        
        logProjectDetail("newGroupData:store", {
          projectId: props.project?.id,
          groupId
        });
        
        // Toggle project to ensure proper UI state
        dispatch({ type: TOGGLE_GROUP_CHAT });
        dispatch({ type: TOGGLE_PROJECT, payload: true });
        
        // Clear newGroupData - this will trigger getChats() to fetch all groups
        // getChats() will use newGroupIdToOpenRef to ensure this group is opened
        dispatch({ type: SET_NEW_GROUP_DATA, payload: null });
      } else {
        logProjectDetail("newGroupData:skip", {
          projectId: props.project?.id,
          building,
          groupId
        });
      }
    }
  }, [newGroupData, props.project?.id])

  useEffect(() => {
    if (newGroupData) return;
    
    if (deeplinkData && chatGroups.length > 0) {
      const { chatGroupId } = deeplinkData;
      if (chatGroupId) {
        let foundGroup = chatGroups.find(e =>
          e.id && e.id.toString() === chatGroupId.toString()
        );
        if (foundGroup) {
          // If the group is already opened (e.g. by getChats), skip openChat.
          // GroupConversation is already mounted and will handle the scroll.
          if (foundGroup.isOpened) {
            logProjectDetail("deeplink:alreadyOpen", {
              projectId: projectDetails?.id,
              chatGroupId
            });
            return;
          }
          logProjectDetail("deeplink:open", {
            projectId: projectDetails?.id,
            chatGroupId
          });
          setOpenDeepGroup(foundGroup);
        } else {
          dispatch({ type: SET_DEEPLINK_DATA, payload: null });
          dispatch({ type: SET_DEEPLINK_LOADING, loading: false });
        }
      }
    }
  }, [chatGroups, deeplinkData, newGroupData])

  const emailInReportPane = isEmailInReportPane({
    companionLayout,
    briefingTabActive,
    selectedRoomEmail,
    roomEmailReplyMode,
    roomRightTab,
  });
  const allowedOpenChatId = [
    userOpenedChatIdRef.current,
    props.groupIdLat,
    deeplinkData && deeplinkData.chatGroupId,
    newGroupIdToOpenRef.current,
  ].filter(Boolean)[0];
  const { openedRoomChat, chatListForOpen } = findOpenedRoomChat({
    projectDocAction,
    selectedRoomEmail,
    roomEmailReplyMode,
    emailInReportPane,
    isFromLatestMsg: props.isFromLatestMsg,
    companionLayout,
    roomListTab,
    chatGroups,
    groupChats: props.groupChats,
    user,
    allowedOpenChatId,
    id,
  });
  const teamsChatInPane = teamsChatForPane({
    openTeamsChat,
    showMember,
    projectDocAction,
    selectedRoomEmail,
    roomEmailReplyMode,
    emailInReportPane,
  });
  const leftPaneHasOpenItem = isLeftPaneItemOpen({
    showMember,
    projectDocAction,
    selectedRoomEmail,
    roomEmailReplyMode,
    emailInReportPane,
    openedRoomChat: firstOpenPaneChat(openedRoomChat, teamsChatInPane),
  });

  // eslint-disable-next-line react-hooks/rules-of-hooks -- false positive from eslint-plugin-react-hooks@4.2.0 (optional chaining earlier in this component)
  useLayoutEffect(() => {
    if (!companionLayout) return;
    const left = leftHeaderRef.current;
    const right = companionHeaderRef.current;
    const details = left && left.closest(".project-details");
    if (!left || !right) return;
    const tabs = left.querySelector(".room-tabs-toolbar");
    const rightTabs = right.querySelector(".room-companion-tabs");
    const search = left.querySelector(".chat_search_div");
    const todoHost = right.querySelector(".room-companion-todo-header-host");
    const setMinHeightIfChanged = (el, px) => {
      if (!el) return;
      const next = `${Math.round(px)}px`;
      if (el.style.minHeight !== next) el.style.minHeight = next;
    };
    // Only the tab rows line up: the task header keeps its own height so the
    // list sits right under it instead of below the left pane's search + create bar.
    const sync = () => {
      if (tabs && rightTabs) setMinHeightIfChanged(rightTabs, tabs.offsetHeight);
      const row3 = search ? search.offsetHeight : 0;
      if (details && row3 > 0) {
        details.style.setProperty("--room-header-row3", `${row3}px`);
      }
    };
    const ro = new ResizeObserver(sync);
    ro.observe(left);
    if (tabs) ro.observe(tabs);
    if (search) ro.observe(search);
    sync();
    return () => {
      ro.disconnect();
      right.style.minHeight = "";
      if (rightTabs) rightTabs.style.minHeight = "";
      if (todoHost) todoHost.style.minHeight = "";
    };
  }, [companionLayout, projectDetails?.id, roomListTab, leftPaneHasOpenItem]);
  const openMessageHost = (leftPaneHasOpenItem || props.isFromLatestMsg) ? messagePaneEl : null;
  const leftTabAccent = isKjuup ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color;
  const leftContentTabActive = !projectDocAction && !showMember;
  const createChoices = roomCreateChoices({
    roomListTab,
    chatsHiddenPref,
    emailFeatureEnabled,
    teamsAvailable: canStartRoomTeamsChat({ teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails }),
  });
  const canCreateRoomItem = !props.project.viewByOwner
    && props.project.isJoin
    && !projectDetails.isDone
    && !projectDocAction
    && createChoices.length > 0;
  const createOffersChoice = createChoices.length > 1;
  const createIcon = createOffersChoice
    ? "add"
    : ({ chat: "add_comment", email: "edit_square", teams: "add_comment" }[createChoices[0]] || "add");
  const createLabels = roomCreateLabels(strings, isGerm, createChoices, canStartRoomTeamsChat({ teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails }));
  // Full-width "New …" bar under the search on every list tab (Alles: a menu of the kinds).
  const roomSearchCreateBtn = canCreateRoomItem ? (
    <div className="room-search-create-wrap room-search-create-wrap--bar" ref={roomCreateSelectorRef}>
      <button
        type="button"
        className="kj-btn kj-btn--secondary kj-btn--sm kj-btn--block room-search-create-bar"
        onClick={handleRoomAddClick}
        title={createLabels.bar}
        aria-haspopup={createOffersChoice ? "menu" : undefined}
        aria-expanded={createOffersChoice ? showRoomCreateSelector : undefined}
      >
        <MaterialIcon icon={createIcon} size={16} />
        <span>{createLabels.bar}</span>
        {createOffersChoice ? <MaterialIcon icon={showRoomCreateSelector ? "expand_less" : "expand_more"} size={16} /> : null}
      </button>
      {showRoomCreateSelector && createOffersChoice && (
        <div className="new-message-type-selector room-search-create-selector" role="menu">
          {createChoices.includes("chat") ? (
            <div
              className="new-message-type-option"
              role="menuitem"
              onClick={openRoomCreateChat}
            >
              <span className="material-symbols-outlined new-message-type-icon" style={{ color: isKjuup ? KJUUP_COLORS.internal : KJUUP_COLORS.base_color }}>groups</span>
              <span>{createLabels.chat}</span>
              {/* The picker also has Teams contacts (Teams chat or Kjuup + Teams group). */}
              {createLabels.withTeams ? (
                <img src={teamsLogo} alt="" className="new-message-type-logo room-create-teams-mark" />
              ) : null}
            </div>
          ) : null}
          {createChoices.includes("email") ? (
            <div
              className="new-message-type-option"
              role="menuitem"
              onClick={() => {
                setShowRoomCreateSelector(false);
                openRoomComposeEmail();
              }}
            >
              <span className="material-symbols-outlined new-message-type-icon" style={{ color: "#e066ed" }}>mail</span>
              <span>{createLabels.email}</span>
            </div>
          ) : null}
        </div>
      )}
    </div>
  ) : null;

  const todosBriefingTabSwitch = (
    <div className="room-tab-switch" style={{ display: "inline-flex", flexWrap: "wrap", gap: 4, background: "transparent", borderRadius: 8, padding: 0 }}>
      <button
        type="button"
        onClick={() => selectRoomTab("todos")}
        style={roomTabActionStyle(todosTabActive, "var(--kjuup-accent)")}
      >
        {strings.email_room_tab_todos || strings.todo || "Aufgaben"}
      </button>
    </div>
  );

  const roomTitleRow = projectDetails ? (
    <div className={`room-header-title-row${companionLayout ? " room-header-title-row--workspace" : ""}`}>
      <div className="room-header-title-copy">
        <h3>
          {!isWideScreen && (
            <div onClick={() => {
              dispatch({ type: TOGGLE_PROJECT, payload: false })
              props.updateOpenProjectsList([]);
            }}>
              <label className="back_icon tabs_mob_view" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', marginRight: '8px' }}>
                <span
                  className="material-symbols-outlined"
                  style={{
                    fontFamily: 'Material Symbols Outlined',
                    fontSize: '24px',
                    width: '24px',
                    height: '24px',
                    color: '#737373',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    fontVariationSettings: '"FILL" 0, "wght" 300, "GRAD" 0, "opsz" 24',
                    fontStyle: 'normal',
                    fontWeight: 300,
                    lineHeight: 1,
                    flexShrink: 0
                  }}
                >
                  keyboard_arrow_left
                </span>
              </label>
            </div>
          )}
          {(props.isFromLatestMsg && props.project.buildingName ? props.project.buildingName?.trim() : props.project.name?.trim())}
        </h3>
        <p
          style={{
            color: (projectDetails.isJoin && !projectDetails.isDone)
              ? "#737373"
              : "#d9deda",
            fontSize: '14px',
            margin: 0,
            marginTop: '2px'
          }}
        >
          {strings.opened_by}
          <span
            style={{
              color: (projectDetails.isJoin && !projectDetails.isDone)
                ? props.project.isInternal
                  ? KJUUP_COLORS.internal
                  : KJUUP_COLORS.base_color
                : "#d9deda",
            }}
          >
            {" "}
            {projectDetails?.openedBy === "Me"
              ? isGerm
                ? "Mir"
                : "Me"
              : projectDetails?.openedBy}
          </span>
        </p>
      </div>
      <div className="room-header-title-actions">
        {!isViewingMode && (
        <div
          onClick={() => {
            setOpenSetting(true);
          }}
          style={{ display: 'flex', cursor: "pointer", justifyContent: "center", zIndex: 100, alignItems: 'center' }}
        >
          <span 
            className="material-symbols-outlined"
            style={{
              fontSize: '24px',
              color: '#737373',
              display: 'inline-block',
              width: '24px',
              height: '24px',
              fontVariationSettings: "'FILL' 0, 'wght' 300, 'GRAD' 0, 'opsz' 24",
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = props.project.isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)'}
            onMouseLeave={(e) => e.target.style.color = '#737373'}
          >
            settings
          </span>
        </div>
        )}
        {(projectDetails.id && !projectDetails.isJoin && !projectDetails.isDone) &&
          !props.project.viewByOwner && (
            <div className="project-action-btn text-right">
              <a
                href="#"
                onClick={(e) =>
                  handleJoin(projectDetails)
                }
              >
                <span className="material-symbols-outlined project-icon-add-circle">add_circle</span>
              </a>
            </div>
          )}
        {!props.project.isInternal ||
          (!props.project.isInternal &&
            props.project.viewByOwner) ? (
          projectDetails?.full_address ? (
            <div className="project-action-btn text-right">
              <a
                href="#"
                onClick={(e) =>
                  handleShow(projectDetails)
                }
              >
                <span className="material-symbols-outlined location-icon">location_on</span>
              </a>
            </div>
          ) : (
            <></>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  ) : null;

  return (
    <React.Fragment>
      {!props.isFromLatestMsg && (
        <div className={`room-workspace${companionLayout ? " room-workspace--companion" : ""}`}>
          {companionLayout && user && projectDetails && !edit.status && !addUserAction.status && !addChatUserAction.status && (
            <div className="room-workspace-header">
              {roomTitleRow}
            </div>
          )}
          <div className={`room-workspace-body${companionLayout && !openSetting ? " room-workspace-body--companion" : ""}`}>
        <div
          className={`chanel_group_userlist_div${todosFullbleed ? " room-todos-fullbleed" : ""}${fillRoomColumn ? " project-details-fill" : ""}`}
          style={{
            backgroundColor: '#fff',
            ...(todosFullbleed || fillRoomColumn
              ? {
                  flex: 1,
                  width: "100%",
                  minWidth: 0,
                  maxWidth: "none",
                  minHeight: 0,
                  height: "100%",
                  alignSelf: "stretch",
                  display: "flex",
                  flexDirection: "column",
                }
              : {}),
          }}
        >
          {viewLoader && (
            <div className="website_loader">
              <div className="loader" />
            </div>
          )}
          <div
            onAnimationEnd={() => {
              setDeleteId(null);
            }}
            className={
              animateHide
                ? "project-details handle-drag"
                : "project-details handle-drag position-relative"
            }
            style={{
              paddingBottom: 0,
              marginBottom: 0,
              backgroundColor: "#fff",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0,
              height: "100%",
              ...(todosFullbleed || fillRoomColumn
                ? { width: "100%", minWidth: 0, maxWidth: "none" }
                : { width: "auto", maxWidth: "none", minWidth: 480, flex: "1 1 0%" }),
            }}
          >
            {user && projectDetails && (
              <div
                ref={detailDiv}
                hide={animateHide}
                className={
                  animateHide
                    ? `w-300 my_project_user r_cont kachada right_btm_ani-enter-done border-radius-0 project-details ${props.project.isInternal ? 'project-internal' : 'project-external'}${todosFullbleed ? " room-todos-fullbleed" : ""}${fillRoomColumn ? " project-details-fill" : ""}${leftPaneHasOpenItem ? " room-message-open" : ""}`
                    : `w-300 my_project_user r_cont kachada right_btm_ani-enter-done border-radius-0 project-details common_box_user_list ${props.project.isInternal ? 'project-internal' : 'project-external'}${todosFullbleed ? " room-todos-fullbleed" : ""}${fillRoomColumn ? " project-details-fill" : ""}${leftPaneHasOpenItem ? " room-message-open" : ""}`
                }
                style={{
                  marginLeft: 0,
                  paddingLeft: (todosFullbleed || leftPaneHasOpenItem) ? 0 : 10,
                  backgroundColor: "#fff",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  borderColor: props.project.isInternal
                    ? KJUUP_COLORS.internal
                    : KJUUP_COLORS.base_color,
                  flex: 1,
                  width: "100%",
                  minWidth: 0,
                  maxWidth: "none",
                  minHeight: 0,
                  overflow: "hidden",
                  boxSizing: "border-box",
                }}
              >
                {!edit.status &&
                  !addUserAction.status &&
                  !addChatUserAction.status && (
                    <>
                      <div
                        ref={leftHeaderRef}
                        className={`room-header-chrome${todosFullbleed ? " room-todos-chrome" : ""}`}
                        style={{
                          paddingTop: leftPaneHasOpenItem || openSetting ? 0 : 4,
                          paddingBottom: 0,
                          ...(leftPaneHasOpenItem || openSetting ? { display: "none" } : {}),
                        }}

                      >
                        {!companionLayout && roomTitleRow}
                        <div
                          ref={infWin}
                          className={
                            toggleInfo
                              ? "details_inner bg-white-user"
                              : "details_inner bg-white-user d-none"
                          }
                          style={{
                            marginRight: "20px",
                            boxShadow: "none",
                            top: -10,
                          }}
                        >
                          <div className="details-item">
                            <div style={{ fontSize: 14, marginBottom: 10 }}>
                              {projectDetails?.projectNo ? (
                                <>
                                  {strings.project_No}
                                  <span style={{ color: "var(--kjuup-accent)" }}>
                                    {projectDetails?.projectNo}
                                  </span>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                            <p
                              style={{
                                color: (projectDetails.isJoin && !projectDetails.isDone)
                                  ? "#737373"
                                  : "#d9deda",
                              }}
                            >
                              {projectDetails?.full_address}
                            </p>
                            {/* <p
                            style={{
                              color: (projectDetails.isJoin && !projectDetails.isDone)
                                ? "#737373"
                                : "#d9deda",
                            }}
                          >
                            {projectDetails?.city} 
                          </p> */}
                          </div>
                          {!props.project.viewByOwner && (props.project.isJoin && !projectDetails.isDone) ? (
                            <></>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div
                          className="room-tabs-toolbar"
                          style={{
                            display: leftPaneHasOpenItem ? "none" : "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: 0,
                            ...(todosFullbleed
                              ? { width: 400, maxWidth: 400, boxSizing: "border-box" }
                              : {}),
                          }}
                        >
                          <div className="room-tabs-content-row" style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: 10, flexWrap: "wrap", width: "100%" }}>
                            <div className="room-tab-switch" style={{ display: "inline-flex", flexWrap: "wrap", gap: 4, background: "transparent", borderRadius: 8, padding: 0 }}>
                              {showRoomOverview && (
                                <button
                                  type="button"
                                  onClick={() => selectRoomTab("overview")}
                                  style={roomTabActionStyle(leftContentTabActive && roomOverviewOpen, leftTabAccent)}
                                >
                                  {strings.room_tab_overview || "Übersicht"}
                                </button>
                              )}
                              <button
                                type="button"
                                onClick={() => selectRoomTab(roomMessagesTab({ isViewingMode, chatsHiddenPref }))}
                                style={roomTabActionStyle(leftContentTabActive && !roomOverviewOpen && ROOM_MESSAGE_TABS.includes(roomListTab), leftTabAccent)}
                              >
                                {strings.room_tab_history || "Verlauf"}
                              </button>
                              <button
                                type="button"
                                onClick={() => selectRoomTab("media")}
                                style={roomTabActionStyle(!!projectDocAction, "var(--kjuup-accent)")}
                              >
                                {strings.room_action_media || "Dateien"}
                              </button>
                            </div>
                            {!companionLayout && !isViewingMode && todosBriefingTabSwitch}
                          </div>
                        </div>
                        {roomListTab !== "todos" && !leftPaneHasOpenItem && !projectDocAction && !roomOverviewOpen && (
                          <div className="search chat_search_div room-header-search">
                            <Form.Group className="room-header-search-field" controlId="exampleForm.ControlInput1">
                              <Form.Control
                                type="text"
                                value={search}
                                onChange={(e) => {
                                  searchProject(e);
                                }}
                                placeholder={strings.search}
                                style={{ paddingLeft: 20, height: 35, borderRadius: 8, fontFamily: '"Work Sans", sans-serif', fontSize: 14, fontWeight: 400 }}
                              />
                            </Form.Group>
                            {roomSearchCreateBtn}
                          </div>
                        )}
                      </div>
                      <div
                        className="wscroll right_wscroll project_scrool"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          flex: 1,
                          height: "auto",
                          minHeight: 0,
                          overflow: "hidden",
                          borderRadius: 0,
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        <CustomScrollbars
                          passthrough
                          overflow={(todosFullbleed || leftPaneHasOpenItem || projectDocAction || roomOverviewOpen) ? "hidden" : "auto"}
                          autoHide
                          autoHideTimeout={200}
                          autoHideDuration={200}
                          className="bottom-bar radius-0"
                        >
                          <div style={{ flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column" }}>
                            <div
                              className="chats_user bg-white-user"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                flex: 1,
                                height: "100%",
                                minHeight: 0,
                                width: "100%",
                                borderRadius: 0,
                                padding: 0,
                                margin: 0,
                              }}
                            >
                              <div
                                className={`company_services chat_services project_chat_user${leftPaneHasOpenItem ? " room-message-pane-host" : ""}${projectDocAction && !leftPaneHasOpenItem ? " room-media-pane-host" : ""}${roomOverviewOpen && !projectDocAction && !leftPaneHasOpenItem ? " room-overview-pane-host" : ""}`}
                                style={
                                  todosFullbleed || leftPaneHasOpenItem || projectDocAction || roomOverviewOpen
                                    ? {
                                        flex: 1,
                                        minHeight: 0,
                                        overflow: "hidden",
                                        display: "flex",
                                        ...(leftPaneHasOpenItem
                                          ? {
                                              marginLeft: 0,
                                              marginRight: 0,
                                              paddingLeft: 0,
                                              paddingRight: 0,
                                              borderRadius: 0,
                                            }
                                          : {}),
                                      }
                                    : undefined
                                }
                              >
                                {leftPaneHasOpenItem ? (
                                  <div
                                    ref={setMessagePaneEl}
                                    className="room-message-pane-open"
                                    style={roomPaneFillStyle}
                                  />
                                ) : (
                                  <>
                                {(!isViewingMode && !companionLayout && (roomListTab === "todos" || roomTodoMounted)) && (
                                  <div
                                    style={{
                                      display: roomListTab === "todos" && !projectDocAction ? "flex" : "none",
                                      flex: 1,
                                      minHeight: 0,
                                      width: "100%",
                                      height: "100%",
                                      overflow: "hidden",
                                    }}
                                  >
                                  <RoomToDoTab
                                    key={projectDetails?.id || props.project?.id}
                                    roomId={projectDetails?.id || props.project?.id}
                                    roomName={projectDetails?.name || props.project?.name || ""}
                                    strings={strings}
                                    active={todosTabActive}
                                    onOpenRoomChat={openRoomChatFromTodo}
                                    onOpenRoomEmail={openRoomEmailFromTodo}
                                  />
                                  </div>
                                )}
                                {projectDocAction && (
                                  <div style={roomPaneFillStyle}>
                                    <BuildingMediaDocs
                                      project_id={projectDetails?.id}
                                      handleEditClose={() => {
                                        setProjectDocAction(false);
                                      }}
                                      hideBack
                                      viewByOwner={props.project.viewByOwner}
                                      isInternal={props.project.isInternal}
                                      emailOnly={chatsHiddenPref}
                                    />
                                  </div>
                                )}
                                {roomOverviewOpen && !projectDocAction && (
                                  <div style={roomPaneFillStyle}>
                                    <RoomOverview
                                      roomId={projectDetails?.id || props.project?.id}
                                      strings={strings}
                                      language={language}
                                      onOpenTasks={() => selectRoomTab("todos")}
                                    />
                                  </div>
                                )}
                                {!projectDocAction && !roomOverviewOpen && roomListTab !== "todos" && !todosFullbleed && (roomListTab === "email" || (!companionLayout && roomListTab === "briefing") ? (
                                  <ProjectEmailsSection
                                    items={filteredRoomEmails}
                                    loading={roomEmailsLoading}
                                    selectedLinkId={selectedRoomEmailLinkId}
                                    isInternal={props.project.isInternal}
                                    onOpenEmail={openRoomEmail}
                                    onRemoveEmail={(item) => removeRoomEmail(item?.id, item)}
                                    asDocuments={roomListTab === "briefing"}
                                    direction={roomListTab === "briefing" ? "incoming" : roomEmailDirection}
                                    emptyLabel={roomListTab === "briefing" ? (strings.email_room_briefings_empty || "No reports in this project") : undefined}
                                    roomBriefingEnabled={!!projectDetails?.dailyBriefingEnabled}
                                    onRoomBriefingChange={roomListTab === "briefing" ? toggleRoomBriefing : undefined}
                                    roomBriefingSaving={roomBriefingSaving}
                                    onBookmarkEmail={toggleRoomEmailBookmark}
                                    isEmailBookmarked={isRoomEmailBookmarked}
                                    deleting={removingRoomEmail}
                                    onDirectionChange={roomListTab === "briefing" ? undefined : async (dir) => {
                                      const allowed = await leaveRoomComposeIfNeeded();
                                      if (!allowed) return;
                                      setSelectedRoomEmail(null);
                                      setSelectedRoomEmailLinkId(null);
                                      setRoomEmailReplyMode(null);
                                      setRoomEmailDirection(dir);
                                    }}
                                  />
                                ) : (() => {
                                  // Find the split point between active and deactivated groups
                                  // The _sortArray function puts deactivated groups at the end
                                  let activeGroups = [];
                                  let deactivatedGroups = [];
                                  let foundDeactivated = false;

                                  chatGroups.forEach((group) => {
                                    if (group.defaultChatGroup) {
                                      activeGroups.push(group);
                                      return;
                                    }
                                    let chatUser = (group.users || []).filter((u) => u.id === user.id);

                                    if (!foundDeactivated) {
                                      if (chatUser.length > 0 && chatUser[0]?.isLeave) {
                                        foundDeactivated = true;
                                        deactivatedGroups.push(group);
                                      } else {
                                        activeGroups.push(group);
                                      }
                                    } else {
                                      deactivatedGroups.push(group);
                                    }
                                  });

                                  const streamQuery = (search || "").trim().toLowerCase();
                                  if (streamQuery) {
                                    const matchesChat = (group) => {
                                      const name = String(translatedGroupNames[group.id] || group.translatedName || group.name || "").toLowerCase();
                                      const last = String(group.lastMessage || "").toLowerCase();
                                      return name.includes(streamQuery) || last.includes(streamQuery);
                                    };
                                    activeGroups = activeGroups.filter(matchesChat);
                                    deactivatedGroups = deactivatedGroups.filter(matchesChat);
                                  }

                                  const teamsQueryMatches = (chat) => !streamQuery
                                    || String(chat.name || "").toLowerCase().includes(streamQuery)
                                    || String(chat.lastMessage?.text || "").toLowerCase().includes(streamQuery);
                                  if (roomListTab === "teams") {
                                    const teamsRows = roomTeamsChats.filter(teamsQueryMatches);
                                    if (!teamsRows.length) {
                                      return (
                                        <div className="email-attachments-empty">
                                          {roomTeamsChats.length > 0
                                            ? strings.chat_search_no_results || (isGerm ? "Keine Treffer" : "No results")
                                            : strings.teams_room_no_chats || (isGerm ? "Noch keine Teams-Chats in diesem Projekt." : "No Teams chats in this project yet.")}
                                        </div>
                                      );
                                    }
                                    return teamsRows.map(_renderRoomTeamsChat);
                                  }

                                  // Create flattened list with headers and items
                                  const flatChatList = [];

                                  if (roomListTab === "all" && !isViewingMode) {
                                    const emailRows = (filteredRoomEmails || [])
                                      .filter((emailItem) => emailItem && emailItem.systemTag !== "daily_briefing")
                                      .filter((emailItem) => !isOutgoingEmail(emailItem))
                                      .map((emailItem) => ({
                                        type: "email",
                                        sortAt: new Date(emailItem.receivedAt || 0).getTime(),
                                        item: emailItem,
                                      }));
                                    const chatRows = activeGroups.map((group) => ({
                                      ...group,
                                      type: "item",
                                      sortAt: new Date(group.messageDate || group.updatedAt || 0).getTime(),
                                    }));
                                    const teamsRows = roomTeamsChats.filter(teamsQueryMatches).map((chat) => ({
                                      type: "teams",
                                      sortAt: new Date(chat.messageDate || 0).getTime(),
                                      item: chat,
                                    }));
                                    const mixed = [...chatRows, ...emailRows, ...teamsRows].sort(
                                      (a, b) => (b.sortAt || 0) - (a.sortAt || 0)
                                    );
                                    const locale = getLocaleForLanguage(language);
                                    let lastMonthKey = null;
                                    mixed.forEach((row) => {
                                      const monthMoment = moment(row.sortAt);
                                      const monthKey = monthMoment.isValid()
                                        ? monthMoment.format("YYYY-MM")
                                        : null;
                                      if (monthKey && monthKey !== lastMonthKey) {
                                        flatChatList.push({
                                          type: "month",
                                          monthKey,
                                          title: monthMoment.locale(locale).format("MMMM, Y"),
                                        });
                                        lastMonthKey = monthKey;
                                      }
                                      flatChatList.push(row);
                                    });
                                  } else if (activeGroups.length > 0) {
                                    flatChatList.push(...activeGroups.map(item => ({ ...item, type: 'item' })));
                                  }

                                  // Add deactivated chats section with header (only if there are deactivated groups)
                                  if (deactivatedGroups.length > 0) {
                                    flatChatList.push({
                                      type: 'header',
                                      title: strings.deactivated_chats,
                                      sectionKey: CHAT_SECTION_KEYS.DEACTIVATED,
                                    });
                                    if (expandedSections[CHAT_SECTION_KEYS.DEACTIVATED]) {
                                      flatChatList.push(...deactivatedGroups.map(item => ({ ...item, type: 'item' })));
                                    }
                                  }

                                  if (roomListTab === "all" && flatChatList.length === 0) {
                                    return (
                                      <div className="email-attachments-empty">
                                        {roomEmailsLoading
                                          ? (strings.email_loading || "Loading...")
                                          : (strings.email_room_all_empty || "No messages in this project yet")}
                                      </div>
                                    );
                                  }

                                  return flatChatList.map((item, index) => {
                                    if (item.type === "month") {
                                      return (
                                        <MonthSeparator
                                          key={`month-${item.monthKey}-${index}`}
                                          title={item.title}
                                        />
                                      );
                                    }
                                    if (item.type === 'header') {
                                      const sectionKey = item.sectionKey || CHAT_SECTION_KEYS.DEACTIVATED;
                                      const isExpanded = !!expandedSections[sectionKey];
                                      return (
                                        <SectionHeader
                                          key={sectionKey + index}
                                          title={item.title}
                                          expanded={isExpanded}
                                          isDeactivated
                                          onClick={() => setExpandedSections(prev => ({
                                            ...prev,
                                            [sectionKey]: !prev[sectionKey]
                                          }))}
                                        />
                                      );
                                    }

                                    if (item.type === "email") {
                                      return _renderRoomStreamEmail(item.item);
                                    }
                                    if (item.type === "teams") {
                                      return _renderRoomTeamsChat(item.item);
                                    }

                                    return _renderRoomChatGroup(item);
                                  });
                                })())}
                                  </>
                                )}
                              </div>
                              <div className="project_verson"></div>
                            </div>
                          </div>
                          <ShareProjectMapDialog
                            company={projectDetails}
                            show={show}
                            handleClose={handleClose}
                          />
                          {showCompanyDialog && (
                            <CompanyListDialog
                              handleClose={(e) => setCompanyDialog(false)}
                              setParam={setParam}
                              companies={companies}
                              handleReJoinCompany={submitReJoinCompany}
                            />
                          )}
                        </CustomScrollbars>
                        {projectDetails?.isDone && roomListTab === "all" && !projectDocAction && (
                          <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", paddingBottom: 10 }}>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}
                            >
                              <span 
                                className="material-symbols-outlined"
                                style={{
                                  fontSize: '24px',
                                  color: '#737373',
                                  display: 'inline-block',
                                  width: '24px',
                                  height: '24px',
                                  fontVariationSettings: "'FILL' 1"
                                }}
                              >
                                check_circle
                              </span>
                            </div>
                            <span style={{ marginTop: 5, fontWeight: 500, color: "#737373", fontSize: "var(--kjuup-type-body)" }}>{strings.room_completed}</span>
                          </div>
                        )}
                        {activeForward && selectedGroups.length > 0 && (
                          <div
                            className="forward-action-buttons-container"
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                              gap: "12px",
                              marginBottom: "12px",
                              marginLeft: "10px",
                              marginRight: "10px",
                            }}
                          >
                            <button
                              onClick={handleCancel}
                              className="btn btn-secondary forward-cancel-btn"
                              style={{
                                flex: 1,
                                textAlign: "center",
                                padding: "10px 24px",
                                borderRadius: "8px",
                                fontSize: "var(--kjuup-type-body)",
                                fontWeight: "500",
                                border: "1.5px solid #d1d5db",
                                backgroundColor: "transparent",
                                color: "#374151",
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease",
                              }}
                            >
                              {strings.cancel}
                            </button>
                            <button
                              onClick={handleForward}
                              className={`btn btn-primary forward-submit-btn ${props.project.isInternal ? 'forward-btn-internal' : 'forward-btn-external'}`}
                              style={{
                                flex: 1,
                                textAlign: "center",
                                padding: "10px 24px",
                                borderRadius: "8px",
                                fontSize: "var(--kjuup-type-body)",
                                fontWeight: "500",
                                cursor: "pointer",
                                transition: "background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease, opacity 0.3s ease, box-shadow 0.3s ease, transform 0.3s ease",
                              }}
                            >
                              {strings.forward}
                            </button>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                {edit.status && (
                  <EditProject
                    project_id={edit.id}
                    handleEditClose={() => {
                      setEdit({
                        status: false,
                        id: null,
                        isInternal: props.project.isInternal,
                      });
                    }}
                    isInternal={props.project.isInternal}
                    isAdmin={projectDetails?.userRole == "admin" ? true : false}
                    name={projectDetails?.name}
                    projectDetails={projectDetails}
                  />
                )}
                {showMember && (
                  <ProjectMembers
                    filterAdmins={filterAdmins}
                    users={users}
                    searchUser={searchUser}
                    _deleteMemberFromProject={_deleteMemberFromProject}
                    project_id={props.project.id}
                    projectDetails={projectDetails}
                    currentMember={currentMember}
                    handleEditClose={() => {
                      setShowMember(false);
                    }}
                    isInternal={props.project.isInternal}
                    members={users}
                    name={props.isFromLatestMsg && props.project.buildingName ? props.project.buildingName : props.project.name}
                    isJoin={(projectDetails.isJoin && !projectDetails.isDone)}
                    viewByOwner={props.project.viewByOwner}
                    leaveProject={leaveProject}
                    isDone={projectDetails.isDone}
                    isAdmin={projectDetails?.userRole == "admin" ? true : false}
                  />
                )}
                {openSetting ? (
                  <ProjectSettings
                    isDone={props.project.isDone}
                    project_id={props.project.id}
                    handleEditClose={() => {
                      setOpenSetting(false);
                    }}
                    onExpandMembers={() => getMembers()}
                    users={users}
                    searchUser={searchUser}
                    filterAdmins={filterAdmins}
                    _deleteMemberFromProject={_deleteMemberFromProject}
                    currentMember={currentMember}
                    projectDetails={projectDetails}
                    isInternal={props.project.isInternal}
                    members={users}
                    name={props.isFromLatestMsg && props.project.buildingName ? props.project.buildingName : props.project.name}
                    isJoin={(projectDetails.isJoin && !projectDetails.isDone)}
                    viewByOwner={props.project.viewByOwner}
                    leaveProject={leaveProject}
                    isAdmin={projectDetails?.userRole == "admin" ? true : false}
                    changeIsDone={(val) => {
                      setProjectDetails({ ...projectDetails, isDone: val })
                      if (val) {
                        goToRoomOverview();
                      }
                    }}
                  />
                ) : (
                  <></>
                )}
                {addUserAction.status && (
                  <AddProjectUser
                    project_id={addUserAction.id}
                    handleEditClose={(isInternal, cID) => {
                      setAddUserAction({
                        status: false,
                        id: null,
                        isInternal: isInternal,
                        cID: cID,
                      });
                      getMembers({ force: true });
                    }}
                    addAsMember={
                      addUserAction?.addAsMember
                        ? addUserAction?.addAsMember
                        : false
                    }
                    setAllUsers={setAllUsers}
                    allUsers={allUsers}
                    setAddChatUserAction={setAddChatUserAction}
                    setAddUserAction={setAddUserAction}
                    isInternal={props.project.isInternal}
                    cID={
                      addUserAction.cID
                        ? addUserAction.cID
                        : props.project.companyId ? props.project.companyId :
                          props.project.company
                            ? props.project.company
                            : props.project.company_id
                    }
                    Mems={members}
                  />
                )}
                {addChatUserAction.status && (
                  <AddProjectChatUser
                    {...roomChatTeamsProps({
                      teamsAvailable: canStartRoomTeamsChat({ teamsConnected, hasActiveKjuupIoPlan, isViewingMode, projectDetails }),
                      chatsHiddenPref,
                    })}
                    onTeamsChatCreated={openCreatedRoomTeamsChat}
                    users={users}
                    project_id={addChatUserAction.id}
                    handleEditClose={() => {
                      setAddChatUserAction({ status: false, id: null });
                      getMembers({ force: true });
                    }}
                    refreshChat={(newGroupId, createdChat) => {
                      invalidateBuildingChat(projectDetails?.id);
                      // Land on chat overview — do not auto-open the conversation.
                      userOpenedChatIdRef.current = null;
                      newGroupIdToOpenRef.current = null;
                      newGroupJustAddedRef.current = true;
                      setRoomListTab(roomMessagesTab({ isViewingMode, chatsHiddenPref }));
                      setProjectEmailAction(false);
                      setSelectedRoomEmail(null);
                      setSelectedRoomEmailLinkId(null);
                      setProjectDocAction(false);
                      const mapped = createdChat?.id
                        ? {
                          ...createdChat,
                          isOpened: false,
                          isLeave: false,
                          isArchived: false,
                          lastMessage: createdChat.lastMessage || "",
                          unseenChatCount: 0,
                          users: createdChat.users || [],
                        }
                        : (newGroupId ? { id: newGroupId, isOpened: false, isLeave: false, lastMessage: "", unseenChatCount: 0, users: [] } : null);
                      if (mapped?.id) {
                        pendingCreatedGroupRef.current = mapped;
                        setChatGroups((prev) => {
                          const closed = (prev || []).map((g) => ({ ...g, isOpened: false }));
                          if (closed.some((g) => String(g.id) === String(mapped.id))) {
                            return closed;
                          }
                          const defaultIdx = closed.findIndex((g) => g.defaultChatGroup);
                          if (defaultIdx >= 0) {
                            const next = [...closed];
                            next.splice(defaultIdx + 1, 0, mapped);
                            return next;
                          }
                          return [mapped, ...closed];
                        });
                      } else {
                        setChatGroups((prev) => (prev || []).map((g) => ({ ...g, isOpened: false })));
                      }
                      const refresh = getChats({ force: true });
                      // Server chat-list cache can lag the create response.
                      setTimeout(() => {
                        getChats({ force: true });
                      }, 800);
                      return refresh;
                    }}
                    setAllUsers={setAllUsers}
                    allUsers={allUsers}
                    isInternal={addChatUserAction.isInternal}
                    cID={
                      addChatUserAction.cID
                        ? addChatUserAction.cID
                        : props.project.companyId
                    }
                    Mems={members}
                  />
                )}
                {viewLoader && (
                  <div className="website_loader">
                    <div className="loader" />
                  </div>
                )}

              </div>
            )}

          </div>
        </div>
        {companionLayout && (
        <div
          className="room-companion-pane"
          style={openSetting ? { display: "none" } : undefined}
        >
          <div className="room-companion-header" ref={companionHeaderRef}>
            <div className="room-companion-tabs">
              {todosBriefingTabSwitch}
            </div>
            <div
              className="room-companion-todo-header-host"
              ref={setTodoHeaderHost}
              style={todosTabActive ? undefined : { display: "none" }}
            />
          </div>
          <div
            className="room-companion-base"
            style={{ display: roomRightTab === "todos" ? "flex" : "none" }}
          >
            {(roomTodoMounted || roomRightTab === "todos") && (
              <RoomToDoTab
                key={projectDetails?.id || props.project?.id}
                roomId={projectDetails?.id || props.project?.id}
                roomName={projectDetails?.name || props.project?.name || ""}
                strings={strings}
                headerHost={todoHeaderHost}
                active={todosTabActive}
                onOpenRoomChat={openRoomChatFromTodo}
                onOpenRoomEmail={openRoomEmailFromTodo}
              />
            )}
          </div>
        </div>
      )}
          </div>
        </div>
      )}
      {props.isFromLatestMsg && (
        <div
          ref={setMessagePaneEl}
          className="room-message-pane-open"
          style={{
            flex: 1,
            minHeight: 0,
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            alignSelf: "stretch",
          }}
        />
      )}
      {/* Opened chat / email / media render inside the messages or report pane */}
      {openMessageHost && createPortal(
        <>
      {chatListForOpen.length > 0 &&
        user &&
        (() => {
          // When project media/docs or the email tab is open, it takes over the right pane
          if (projectDocAction) return null;
          if (!companionLayout && !props.isFromLatestMsg && !userOpenedChatIdRef.current && (roomListTab === "email" || roomListTab === "briefing" || roomListTab === "todos")) return null;
          if ((selectedRoomEmail || roomEmailReplyMode) && !emailInReportPane) return null;
          // Only mount a chat the user opened this visit. Leftover
          // `isOpened` from a previous visit would subscribe on room entry
          // and clear the unread counter before the chat group is clicked.
          const allowedOpenId =
            userOpenedChatIdRef.current ||
            props.groupIdLat ||
            deeplinkData?.chatGroupId ||
            newGroupIdToOpenRef.current;
          const openedChats = chatListForOpen.filter(chat =>
            chat.isOpened &&
            allowedOpenId &&
            String(chat.id) === String(allowedOpenId) &&
            (props.isFromLatestMsg || chat.building === id || String(chat.building) === String(id))
          );
          // Only take the first opened chat (if any)
          const chat = openedChats[0];
          if (!chat) return null;
          const index = props.groupChats.indexOf(chat);
          return (
            chat.isPilot ?
              <div
                className="room-message-pane-fill"
                style={roomPaneFillStyle}
              >
                <div
                  className="room-message-pane-fill"
                  style={roomPaneFillStyle}
                >
                  <KjuupPilotChat
                    key={0}
                    projectDetails={projectDetails}
                    members={members}
                    project={props.project}
                    handleClose={(id, options) => {
                      if (options?.backToLatest || options?.closeOnly) {
                        dismissOpenRoomChat();
                        return;
                      }
                      openChat({ id });
                    }}
                    chat={{}}
                    addMember={_addMemberCallBack}
                    openChatArr={props.groupChats}
                    getChats={getChats}
                    leaveProject={leaveProject}
                    isInternal={addChatUserAction.isInternal}
                    cID={addChatUserAction.cID}
                    users={users}
                    fromActivity={
                      props.fromActivity
                        ? props.fromActivity
                        : (!projectDetails.isJoin && !projectDetails.isDone)
                    }
                    isFromLatestMsg={props.isFromLatestMsg}
                  />
                </div>
              </div>
              :
              chat.isOpened ?
                <div
                  className="room-message-pane-fill"
                  style={roomPaneFillStyle}
                >
                  <GroupConversation
                    refreshChat={() => {
                      getChats();
                    }}
                    showBackArrow
                    key={chat.id || `chat-${index}`}
                    projectDetails={projectDetails}
                    members={members}
                    project={props.project}
                    handleClose={(id, options) => {
                      dispatch({ type: SET_DEEPLINK_DATA, payload: null });
                      if (options?.backToLatest || options?.closeOnly) {
                        dismissOpenRoomChat();
                        return;
                      }
                      if (options?.isLeave) {
                        const updated = chatGroups.map((g) =>
                          g.id === id ? { ...g, isOpened: false, isLeave: true, disabled: true } : g
                        );
                        const sorted = _sortArray(updated);
                        setChatGroups(sorted);
                        props.updateGroupChats(sorted);
                        restoreReturnTab();
                        return;
                      }
                      openChat({ id });
                    }}
                    chat={chat}
                    addMember={_addMemberCallBack}
                    openChatArr={props.groupChats}
                    getChats={getChats}
                    leaveProject={leaveProject}
                    isInternal={addChatUserAction.isInternal}
                    cID={addChatUserAction.cID}
                    users={users}
                    isFromLatestMsg={props.isFromLatestMsg}
                    isFromTodo={props.isFromTodo || (deeplinkScrollTarget?.chatGroupId?.toString() === chat.id?.toString())}
                    scrollToMessageId={props.scrollToMessageId || (deeplinkScrollTarget?.chatGroupId?.toString() === chat.id?.toString() ? deeplinkScrollTarget.messageId : undefined)}
                    scrollToMessagePage={props.scrollToMessagePage || (deeplinkScrollTarget?.chatGroupId?.toString() === chat.id?.toString() ? deeplinkScrollTarget.page_no : undefined)}
                    scrollRequestId={deeplinkScrollTarget?.chatGroupId?.toString() === chat.id?.toString() ? deeplinkScrollTarget.requestId : undefined}
                    onMessageHighlighted={props.onMessageHighlighted || (deeplinkScrollTarget?.chatGroupId?.toString() === chat.id?.toString() ? () => { setDeeplinkScrollTarget(null); } : undefined)}
                    onBackToParent={props.onBackToParent}
                    fromActivity={
                      props.fromActivity
                        ? props.fromActivity
                        : (!projectDetails.isJoin && !projectDetails.isDone)
                    }
                  />
                </div>
                :
                null
          );
        })()}
      {renderRoomTeamsChatPane()}
      {(selectedRoomEmail || roomEmailReplyMode) && !projectDocAction && (
        <div
          className="room-message-pane-fill"
          style={roomPaneFillStyle}
        >
          <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
            <div style={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
              {roomEmailReplyMode !== "new" && loadingRoomEmail && !selectedRoomEmail?.bodyHtml && !selectedRoomEmail?.bodyText ? (
                <div className="email-attachments-empty">{strings.email_loading || "Loading..."}</div>
              ) : roomEmailReplyMode !== "new" && (selectedRoomEmail?.systemTag === "daily_briefing" || briefingTabActive) ? (
                <DailyBriefingDocument
                  email={selectedRoomEmail}
                  onClose={closeRoomEmail}
                  onDelete={() => removeRoomEmail(selectedRoomEmail?.id || selectedRoomEmailLinkId, selectedRoomEmail)}
                />
              ) : (
                <EmailDetailView
                  ref={roomEmailDetailRef}
                  email={roomEmailReplyMode === "new" ? null : selectedRoomEmail}
                  onClose={closeRoomEmail}
                  onOpenChatLink={openChatFromNotificationEmail}
                  onChangeProject={openRoomEmailAssignModal}
                  onRemoveProject={(em, bId) => classifyRoomEmail(
                    em?.id || em?._id || em?.messageId || em?.providerMessageId,
                    "unlink",
                    "",
                    bId || projectDetails?.id || props.project?.id
                  )}
                  activeFolder={
                    roomEmailReplyMode === "draft" || roomEmailDirection === "draft"
                      ? "DRAFT"
                      : (selectedRoomEmail?.direction === "outgoing" || roomEmailDirection === "outgoing")
                        ? "SENT"
                        : "INBOX"
                  }
                  buildings={(() => {
                    const currentRoom = projectDetails?.id
                      ? [{
                          id: projectDetails.id,
                          name: projectDetails.name || props.project?.name || "",
                          themeColor: projectDetails.themeColor || null,
                          projectNo: projectDetails.projectNo || "",
                          aliases: [],
                        }]
                      : [];
                    const list = classificationBuildings.length ? [...classificationBuildings] : currentRoom;
                    if (currentRoom[0] && !list.some((b) => String(b.id) === String(currentRoom[0].id))) {
                      list.unshift(currentRoom[0]);
                    }
                    return list;
                  })()}
                  initialBuildingId={roomEmailReplyMode === "new" ? (projectDetails?.id || props.project?.id) : null}
                  onReply={() => setRoomEmailReplyMode("reply")}
                  onReplyAll={() => setRoomEmailReplyMode("replyAll")}
                  onForward={() => setRoomEmailReplyMode("forward")}
                  onToggleBookmark={toggleRoomEmailBookmark}
                  bookmarkProjectId={projectDetails?.id || props.project?.id || null}
                  onDelete={() => removeRoomEmail(selectedRoomEmail?.id || selectedRoomEmailLinkId, selectedRoomEmail)}
                  replyMode={roomEmailReplyMode}
                  onCancelReply={() => setRoomEmailReplyMode(null)}
                  onEditDraft={() => setRoomEmailReplyMode("draft")}
                  accountId={
                    selectedRoomEmail?.accountId
                    || selectedRoomEmail?.emailAccountId
                    || selectedRoomEmail?.__accountId
                    || selectedRoomEmail?.emailAccount
                    || emailAccounts[0]?.id
                    || emailAccounts[0]?._id
                  }
                  emailAccounts={emailAccounts}
                  onSent={(meta) => {
                    setRoomEmailReplyMode(null);
                    if (meta && meta.savedDraft) {
                      setRoomEmailDirection("draft");
                      loadRoomEmails(projectDetails?.id, "draft", "email");
                      return;
                    }
                    if (meta && meta.sentDraft) {
                      setSelectedRoomEmail(null);
                      setSelectedRoomEmailLinkId(null);
                      setRoomEmailDirection("outgoing");
                      loadRoomEmails(projectDetails?.id, "outgoing", "email");
                      return;
                    }
                    loadRoomEmails(
                      projectDetails?.id,
                      roomListTab === "all" ? "incoming" : roomEmailDirection,
                      roomListTab === "all" ? "all" : roomEmailKind
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>
      )}
        </>
      , openMessageHost)}

      {assignModalEmail && (
        <EmailAssignModal
          email={assignModalEmail}
          buildings={classificationBuildings}
          onClassify={classifyRoomEmail}
          onClose={() => setAssignModalEmail(null)}
          strings={strings}
        />
      )}

      {/* Mute/Unmute Confirmation Modal */}
      <Modal
        show={showMuteConfirm}
        onHide={cancelMuteUnmute}
        animation={false}
        centered
      >
        <Modal.Body className="modal-body-relative">
          <p>
            {isMuteAction
              ? (isGerm
                ? "Möchten Sie diesen Chat wirklich stummschalten? Sie erhalten keine Benachrichtigungen mehr für neue Nachrichten."
                : "Do you really want to mute this chat? You will no longer receive notifications for new messages.")
              : (isGerm
                ? "Möchten Sie die Stummschaltung dieses Chats wirklich aufheben? Sie erhalten wieder Benachrichtigungen für neue Nachrichten."
                : "Do you really want to unmute this chat? You will receive notifications for new messages again.")
            }
          </p>
        </Modal.Body>
        <Modal.Footer style={{ border: 'none' }}>
          <Button
            variant="secondary"
            onClick={cancelMuteUnmute}
            style={{
              backgroundColor: "var(--kjuup-bg)",
              color: props.project?.isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)',
              border: `1px solid ${props.project?.isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)'}`
            }}
          >
            {strings.cancel}
          </Button>
          <Button
            variant="primary"
            onClick={confirmMuteUnmute}
            style={{
              backgroundColor: props.project?.isInternal ? 'var(--kjuup-internal)' : 'var(--kjuup-accent)',
              color: "white",
              border: "none"
            }}
          >
            {strings.ok}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  const {
    openProjects,
    updateProjectActionFire,
    projects,
    groupChats,
    forwardGroupMessages,
    draftMessages,
    updateGroupMessage,
    isOpenByOwner,
    openBottomProjects,
  } = state;
  return {
    projects: projects,
    openProjects: openProjects,
    updateProjectActionFire: updateProjectActionFire,
    groupChats: groupChats,
    forwardGroupMessages: forwardGroupMessages,
    draftMessages: draftMessages,
    updateGroupMessage: updateGroupMessage,
    isOpenByOwner,
    openBottomProjects: openBottomProjects,
    pendingBookmarks: state.pendingBookmarks,
    bookmarkTodoEventSeq: state.bookmarkTodoEventSeq,
    bookmarkedChatIds: state.bookmarkedChatIds,
    todoListRefreshTrigger: state.todoListRefreshTrigger,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateProjects: (projects) =>
      dispatch({ type: PROJECTS, projects: projects }),
    updateOpenProjectsList: (projects) =>
      dispatch({ type: OPEN_PROJECTS, openProjects: projects }),
    updateProjectAction: (value) =>
      dispatch({
        type: UPDATE_PROJECT_ACTION_FIRE,
        updateProjectActionFire: value,
      }),
    updateGroupChats: (chats) =>
      dispatch({ type: GROUP_CHATS, groupChats: chats }),
    updateForwardGroupMessage: (groupMessages) =>
      dispatch({
        type: FORWARD_GROUP_MESSAGES,
        forwardGroupMessages: groupMessages,
      }),
    updateDraftMessages: (msg) =>
      dispatch({ type: DRAFT_MESSAGES, draftMessages: msg }),
    isOwnerOpenProject: (open) => dispatch({ type: IS_OPEN_BY_OWNER, open }),
    updateAllBadgeCount: (count) =>
      dispatch({ type: ALL_BADGE_COUNT, unSeenAllCount: count }),
    updateBottomOpenProjects: (projects) =>
      dispatch({ type: OPEN_BOTTOM_PROJECTS, openBottomProjects: projects }),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(memo(ProjectDetailSection)));
